<style lang="stylus" scoped>
    .aimsglist
        &.ai-status
            padding-top 32px!important;
        .msgitem:not(:last-child)
            margin-bottom 24px
        .aimsg-toptip
            display flex
            padding 0 15px
            height 36px
            align-items center
            position fixed
            top 40px
            left 50%
            transform translateX(-50%)
            border-radius: 8px;
            border: 0.5px solid rgba(255, 255, 255, 0.20);
            background: var(--bg-color-aimsg-toptip);
            box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
            z-index 2
            p
                color #fff
                font-size 12px
                line-height 16px
                white-space nowrap
            .aimsg-close
                height 20px
                border-radius: 4px;
                background: var(--themeColor);
                font-size: 11px;
                line-height: 8px;
                white-space nowrap
                padding: 6px 8px;
                color: #FFF;
                margin-left 12px
                cursor pointer
</style>

<template>
    <div class="aimsglist" ref="msgList" :class="{ 'ai-status': aiStatus }">
        <div class="aimsg-toptip" v-if="aiStatus">
            <p v-html="analysisStr"></p>
            <div class="aimsg-close" @click="cleanStatus">{{ $t("cleanStatus") }}</div>
        </div>
        <component
            class="msgitem"
            ref="msgItemList"
            v-for="(item, index) in msgList"
            :key="`${item.dialogType}-${index}`"
            :is="setDialog(item.dialogType)"
            :id="item.id"
            :shapeId="item.shapeId"
            :inputStr="item.inputStr"
            :botUserInput="item.botUserInput"
            :action="item.action"
            :aiStatus="item.aiStatus"
            :str="item.str"
            :msgType="item.msgType"
            :toolList="item.toolList"
            :sessionId="sessionId"
            :fileName="item.fileName"
            :fileType="item.fileType"
            :pictures="item.pictures"
            :localImg="item.localImg"
            :callback="item.callback"
            :mode="item.mode"
            :imgDatas="item.imgDatas"
            :suggestTags="item.suggestTags"
            @clickTemplateCase="clickTemplateCase"
            @clickImglist="clickImglist"
            @clickRefresh="clickRefresh"
            @imgLoaded="imgLoaded"
            @clickToolBtn="clickToolBtn"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import userDialog from "@/app/components/ai3/userDialog.vue";
    import botDialog from "@/app/components/ai3/botDialog.vue";
    import sysDialog from "@/app/components/ai3/sysDialog.vue";
    import { aiResType, userMsgType, aiStatusType, analyseModeMap } from "./enum";
    import AiSocket from "@/app/mixin/aiSocket";
    import { parseMermaidText } from "@/public/utils/tool.js";
    import axios from "axios";
    import { urls } from "@/public/utils/env.js";

    const analyseModeMapValues = [];
    analyseModeMap.forEach((value) => {
        analyseModeMapValues.push(value);
    });

    let map = {
        user: "userDialog",
        bot: "botDialog",
        sys: "sysDialog",
    };
    @Component({
        components: {
            botDialog,
            userDialog,
            sysDialog,
        },
    })
    export default class AiMsgList extends AiSocket {
        @Prop()
        agree;
        @Prop()
        talkStatus;

        msgList = [];
        msgId = 1;
        msgMode = "";
        from = "rightPanel";

        clearMsgList() {
            this.msgList = [];
            this.msgId = 1;
        }

        setDialog(str) {
            return map[str];
        }

        scrollFlag = false;
        scrollToBottom() {
            if (this.scrollFlag) return;
            this.scrollFlag = true;
            setTimeout(() => {
                this.$nextTick(() => {
                    this.$emit("selfScrollTo");
                });
                this.scrollFlag = false;
            }, 30);
        }

        imgLoaded(id: number) {
            if (id == this.msgId - 1) {
                this.scrollToBottom();
            }
        }

        deleteMsg(id) {
            for (let i = this.msgList.length - 1; i >= 0; i--) {
                if (this.msgList[i].id == id) {
                    this.msgList.splice(i, 1);
                    break;
                }
            }
        }

        replaceMsg(id, obj) {
            for (let i = this.msgList.length - 1; i >= 0; i--) {
                if (this.msgList[i].id == id) {
                    this.msgList.splice(i, 1, obj);
                    break;
                }
            }
        }

        getMsg(id) {
            for (let item of this.msgList) {
                if (id == item.id) {
                    return item;
                }
            }
            return null;
        }

        pushMsg(obj) {
            this.msgList.push(obj);
        }
        pushHolidayText() {
            if (!this.isAIOpened && !this.vip) {
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.holidayText,
                });
                this.isAIOpened = true;
            }
        }
        addUserMsg(str: string, msgType: number = userMsgType.text, fileName?: string, fileType?: string) {
            let obj = {
                id: this.msgId++,
                dialogType: "user",
                msgType,
                str: str,
                fileName,
                fileType,
            };
            this.msgList.push(obj);
            this.scrollToBottom();
        }

        addUserMsgForPicture(str: string, msgType: number = userMsgType.text, pictures: Array<string>) {
            let obj = {
                id: this.msgId++,
                dialogType: "user",
                msgType,
                str: str,
                pictures,
            };
            this.msgList.push(obj);
            console.log(this.msgList, ">>.123123");
            this.scrollToBottom();
        }

        addSysMsg(str: string) {
            let obj = {
                id: this.msgId++,
                dialogType: "sys",
                msgType: "text",
                str: str,
            };
            this.msgList.push(obj);
            this.scrollToBottom();
        }

        addBotMsg(msgType = 0, str = "", order = "", localImg = "", callback = () => {}, toolList = []) {
            const id = this.msgId++;
            let obj = {
                id: id,
                dialogType: "bot",
                msgType,
                str: str,
                order: order,
                localImg,
                callback,
                toolList,
            };
            this.msgList.push(obj);
            this.scrollToBottom();
            return id;
        }

        addTagMsg(key: number, str: string) {
            if (key == 3) {
                // 如何进行亿图分析
                this.msgEvent({
                    action: "userMsg",
                    str: str,
                    order: "",
                });
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.helpMsg,
                    order: "",
                });
                this.$emit("toggleBan", false);
                this.scrollToBottom();
            } else {
                this.msgEvent({
                    action: "userTask",
                    str: str,
                });
            }
        }

        get shapeId() {
            return this.$store.state.shape.id;
        }
        get isAIOpened() {
            return this.$store.state.user.isAIOpened;
        }
        set isAIOpened(result) {
            this.$store.commit("setState", {
                type: "isAIOpened",
                data: result,
            });
        }
        getMode() {
            let obj = {
                flowchart: "flowchart-m",
                mindmap: "mindmap-md",
                table: "form",
                list: "list",
                timeline: "timeline",
                swot: "swot",
                pest: "pest",
                canvas: "leanCanvas2",
                portrait: "userProfile",
                story: "userStory",
                line: "echart-line",
                bar: "echart-bar",
                pie: "echart-pie",
                scatter: "echart-scatter",
                candlestick: "echart-candlestick",
                radar: "echart-radar",
                boxplot: "echart-boxplot",
                heatmap: "echart-heatmap",
                graphChart: "echart-graph",
                sunburst: "echart-sunburst",
                parallel: "echart-parallel",
                sankey: "echart-sankey",
                funnel: "echart-funnel",
                gauge: "echart-gauge",
                pictureAnalysis: "image",
                textAnalysis: "text-analyse",
            };
            return obj.hasOwnProperty(this.aiStatus) ? obj[this.aiStatus] : "default";
        }
        getAnalyseMode(str) {
            let mode = analyseModeMap.get(this.aiStatusId);
            if (str) {
                mode = mode.replace(/(\w-)(\w*)/, "$1chat");
            }
            return mode;
        }
        useReplaceOld = false;

        getSessionId() {
            let sessionId = this.talkStatus == 2 ? 1 : this.tempSessionId;
            return {
                session_id: sessionId,
            };
        }
        async addUserTask(id = 0, str: string) {
            let mode = this.getMode();
            mode = mode == "default" ? "chat" : mode;
            this.msgMode = mode;
            if (id) {
                const oldMsg = this.getMsg(id);
                if (oldMsg) {
                    mode = oldMsg.mode;
                }

                if (this.useReplaceOld) {
                    this.replaceMsg(id, {
                        id: id,
                        dialogType: "bot",
                        msgType: aiResType.thinking,
                    });
                }
            }
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);
            let extraParams: any = {};
            if (this.commandMode != "definite") {
                extraParams = {
                    ...this.getSessionId(),
                };
                this.$emit("setTalkStatus", 3);
            }

            // AI4.0，自由提问
            if (mode === "text-analyse") {
                extraParams.prompt = str;
                extraParams.extra = window["_view"]._activeShape ? this.activeText : "";
            }

            const res = await this.aiResponse(str, mode, extraParams).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            if (res) {
                const addMsg = () => {
                    for (let i = this.msgList.length - 1; i >= 0; i--) {
                        if (this.msgList[i].id == msgId) {
                            let temp = {
                                id: this.msgId++,
                                dialogType: "bot",
                                msgType: res.msgType,
                                action: "userTask",
                                aiStatus: this.aiStatus,
                                aiStatusType: this.aiStatusType,
                                inputStr: str,
                                str: res.data,
                                toolList: res.toolList,
                                mode: mode,
                                recg_kw_onceFlag: this.recg_kw_onceFlag,
                            };
                            this.deleteMsg(msgId);
                            this.pushMsg(temp);
                            this.pushHolidayText();
                            // this.replaceMsg(msgId, temp);
                            break;
                        }
                    }
                    this.recg_kw_onceFlag = true;
                    this.$bus.$emit("refreshAIPoint", true);
                    this.scrollToBottom();
                    this.$emit("toggleBan", false);
                };
                if (res.status == "error") {
                    addMsg();
                } else if (mode == "chat" && !this.matchMode) {
                    this.receiveDoneCallback = () => {
                        addMsg();
                    };
                } else {
                    addMsg();
                }
            } else {
                this.$emit("toggleBan", false);
            }
            console.log(this.msgList);
        }

        async presetTag(id: number, str: string, botUserInput: string) {
            // 预置固定指令
            if (id && this.useReplaceOld) {
                this.replaceMsg(id, {
                    id: id,
                    dialogType: "bot",
                    msgType: aiResType.thinking,
                });
            }
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);
            const mode = "definite";
            this.msgMode = mode;
            const res = await this.aiResponse(str, mode).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            if (res) {
                for (let i = this.msgList.length - 1; i >= 0; i--) {
                    if (this.msgList[i].id == msgId) {
                        let temp = {
                            id: this.msgId++,
                            dialogType: "bot",
                            msgType: res.msgType,
                            action: "presetTag",
                            aiStatus: this.aiStatus,
                            botUserInput: botUserInput,
                            inputStr: str,
                            str: res.data,
                            toolList: res.toolList,
                            mode: mode,
                        };
                        this.deleteMsg(msgId);
                        this.pushMsg(temp);
                        this.pushHolidayText();
                        // this.replaceMsg(msgId, temp);
                        break;
                    }
                }
                this.scrollToBottom();
                this.$bus.$emit("refreshAIPoint", true);
            }
            this.$emit("toggleBan", false);
        }

        async aiTextCheck(id: number, str: string) {
            // 文本检测
            if (id && this.useReplaceOld) {
                this.replaceMsg(id, {
                    id: id,
                    dialogType: "bot",
                    msgType: aiResType.thinking,
                });
            }
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);
            const mode = "text-error-correction";
            this.msgMode = mode;
            const res = await this.aiResponse(str, mode).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            console.log("aiTextCheck", res);
            if (res) {
                for (let i = this.msgList.length - 1; i >= 0; i--) {
                    if (this.msgList[i].id == msgId) {
                        let temp = {
                            id: this.msgId++,
                            dialogType: "bot",
                            msgType: res.msgType,
                            inputStr: str,
                            action: "textCheck",
                            aiStatus: this.aiStatus,
                            str: res.data,
                            toolList: res.toolList,
                            shapeId: this.shapeId,
                            mode,
                        };
                        this.deleteMsg(msgId);
                        this.$nextTick(() => {
                            this.pushMsg(temp);
                            this.pushHolidayText();
                            this.scrollToBottom();
                        });
                        // this.replaceMsg(msgId, temp);
                        break;
                    }
                }
                this.$bus.$emit("refreshAIPoint", true);
            }
            this.$emit("toggleBan", false);
        }

        async extraTask(id = 0, str: string, extra?, fileName = "") {
            // 携带文件的任务
            let mode = this.getMode();
            mode = mode == "default" ? "chat-extra" : mode;
            this.msgMode = mode;
            if (id) {
                const oldMsg = this.getMsg(id);
                if (oldMsg) {
                    mode = oldMsg.mode;
                    extra = oldMsg.extra;
                }
                if (this.useReplaceOld) {
                    this.replaceMsg(id, {
                        id: id,
                        dialogType: "bot",
                        msgType: aiResType.thinking,
                    });
                }
            }
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);
            const extraParams = {
                extra,
                ...this.getSessionId(),
            };
            this.$emit("setTalkStatus", 3);
            const res = await this.aiResponse(str, mode, extraParams).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            if (res) {
                for (let i = this.msgList.length - 1; i >= 0; i--) {
                    if (this.msgList[i].id == msgId) {
                        let temp = {
                            id: this.msgId++,
                            dialogType: "bot",
                            msgType: res.msgType,
                            action: "fileTask",
                            aiStatus: this.aiStatus,
                            inputStr: str,
                            str: res.data,
                            toolList: res.toolList,
                            botUserInput: fileName,
                            extra,
                            mode,
                        };
                        this.deleteMsg(msgId);
                        this.pushMsg(temp);
                        this.pushHolidayText();
                        // this.replaceMsg(msgId, temp);
                        break;
                    }
                }
                this.scrollToBottom();
                this.$bus.$emit("refreshAIPoint", true);
            }
            this.$emit("toggleBan", false);
        }

        async aiAnalyseTask(id: number, str: string, shapeStr) {
            // ai分析
            let mode = this.getAnalyseMode(str);
            this.msgMode = mode;
            let botUserInput = ""; // 自动发送的分析关键词
            if (id && this.useReplaceOld) {
                this.replaceMsg(id, {
                    id: id,
                    dialogType: "bot",
                    msgType: aiResType.thinking,
                });
            }
            let extraParams = {};
            if (str || /-chat/.test(mode)) {
                // 存在用户输入，将shapestr存放至extra
                Object.assign(extraParams, { extra: shapeStr });
                this.$emit("setAnalyseId", 0);
            } else {
                botUserInput = this.aiAnalyseTempUserInput;
                this.aiAnalyseTempUserInput = "";
                str = shapeStr;
                this.$emit("setAnalyseId", this.aiStatusId);
            }

            Object.assign(extraParams, this.getSessionId());
            this.$emit("setTalkStatus", 3);
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);
            const res = await this.aiResponse(str, mode, extraParams).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            if (res) {
                for (let i = this.msgList.length - 1; i >= 0; i--) {
                    if (this.msgList[i].id == msgId) {
                        let temp = {
                            id: this.msgId++,
                            dialogType: "bot",
                            msgType: res.msgType,
                            action: "aiAnalyse",
                            aiStatus: this.aiStatus,
                            inputStr: str,
                            botUserInput: botUserInput,
                            str: res.data,
                            toolList: res.toolList,
                            aiStatusId: this.aiStatusId,
                            mode: mode,
                        };
                        this.deleteMsg(msgId);
                        this.pushMsg(temp);
                        this.pushHolidayText();
                        // this.replaceMsg(msgId, temp);
                        break;
                    }
                }
                this.scrollToBottom();
                this.$bus.$emit("refreshAIPoint", true);
            }
            this.$emit("toggleBan", false);
        }

        async flowchartAnalyse(id: number, str: string | string[], shapeStr = "", imgDatas) {
            // ai流程图分析
            let mode = analyseModeMap.get(this.flowAnalyseId);
            this.msgMode = mode;
            let botUserInput = ""; // 自动发送的分析关键词
            if (id && this.useReplaceOld) {
                this.replaceMsg(id, {
                    id: id,
                    dialogType: "bot",
                    msgType: aiResType.thinking,
                });
            }
            let extraParams: any = {
                img_datas: imgDatas,
            };
            if (Object.prototype.toString.call(str) == "[object Array]") {
                extraParams = {
                    extra: str[1],
                };
                str = str[0];
                botUserInput = this.aiAnalyseTempUserInput;
                this.aiAnalyseTempUserInput = "";
            }
            if (shapeStr) {
                // <新增流程图>流程
                extraParams = {
                    extra: shapeStr,
                };
            }
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);

            Object.assign(extraParams, this.getSessionId());
            this.$emit("setTalkStatus", 3);

            const res = await this.aiResponse(str, mode, extraParams).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            if (res) {
                if (this.msgList.find((item) => item.id === msgId)) {
                    this.deleteMsg(msgId);
                    const temp = {
                        id: this.msgId++,
                        dialogType: "bot",
                        msgType: res.msgType,
                        action: "flowAnalyse",
                        aiStatus: this.aiStatus,
                        inputStr: str,
                        botUserInput: botUserInput,
                        str: res.data,
                        toolList: res.toolList,
                        aiStatusId: this.aiStatusId,
                        mode: mode,
                        imgDatas,
                    };
                    this.pushMsg(temp);
                    // this.addSuggestBotDialog(mode, temp);
                    this.pushHolidayText();
                    this.scrollToBottom();
                }
                this.$bus.$emit("refreshAIPoint", true);
            }
            this.$emit("toggleBan", false);
        }

        isPictureTask = false;

        async pictureTask(id = 0, str: string, extra?, imgDatas = [], mode = "image") {
            this.aiStatus = "pictureAnalysis";
            this.aiStatusType = null;
            this.$emit("toggleAIStatus", "pictureAnalysis");
            this.isPictureTask = true;

            // 携带图片的任务
            if (id) {
                const oldMsg = this.getMsg(id);
                if (oldMsg) {
                    mode = oldMsg.mode;
                    extra = oldMsg.extra;
                }
                if (this.useReplaceOld) {
                    this.replaceMsg(id, {
                        id: id,
                        dialogType: "bot",
                        msgType: aiResType.thinking,
                    });
                }
            }
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);
            const extraParams = {
                extra,
            };
            this.imgDatas = imgDatas;
            this.msgMode = mode;
            Object.assign(extraParams, this.getSessionId());
            this.$emit("setTalkStatus", 3);

            console.log(extraParams, ">>>extraParams");

            const res = await this.aiResponse(str, mode, extraParams).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            this.isPictureTask = false;
            if (res) {
                if (this.msgList.find((item) => item.id === msgId)) {
                    const temp = {
                        id: this.msgId++,
                        dialogType: "bot",
                        msgType: res.msgType,
                        action: "pictureTask",
                        aiStatus: this.aiStatus,
                        inputStr: str,
                        str: res.data,
                        toolList: res.toolList,
                        extra,
                        mode,
                        imgDatas,
                    };
                    this.deleteMsg(msgId);
                    this.pushMsg(temp);
                    // this.addSuggestBotDialog(mode, temp);
                    this.pushHolidayText();
                }
                this.scrollToBottom();
                this.$bus.$emit("refreshAIPoint", true);
            }
            this.$emit("toggleBan", false);
        }

        /**
         * （流程图、甘特图、图表、组织结构图）同一个图，使用分析后会建议使用其他分析类型
         */
        addSuggestBotDialog(mode, msgObj) {
            const urlStr = (msgObj.imgDatas || []).join("");
            if (urlStr === "") {
                return;
            }

            const diagramTypes = ["flowchart", "gantt", "graph", "org"];
            for (let i = 0; i < diagramTypes.length; i++) {
                const type = diagramTypes[i];
                if (mode.includes(type)) {
                    const oldModeList = this.msgList
                        .filter((item) => {
                            return (item.mode || "").includes(type) && (item.imgDatas || []).join("") === urlStr;
                        })
                        .map((item) => item.mode);
                    const suggestTags = analyseModeMapValues.filter((item) => {
                        return (
                            item.includes(type) && item !== mode && !/chat-v$/.test(item) && item !== "graph-analyse" && !oldModeList.includes(item)
                        );
                    });
                    if (suggestTags.length > 0) {
                        const suggest = {
                            ...msgObj,
                            id: this.msgId++,
                            msgType: aiResType.diagramAnalyseSuggest,
                            str: this.$t("suggest-tip"),
                            toolList: [],
                            suggestTags,
                        };
                        this.pushMsg(suggest);
                        return;
                    }
                }
            }
        }

        async extraEchartTask(id = 0, str: string, extra?, fileName = "") {
            // 携带文件的任务
            let mode = this.getMode();
            mode = mode == "default" ? "echart" : mode;
            this.msgMode = mode;
            if (id) {
                const oldMsg = this.getMsg(id);
                if (oldMsg) {
                    mode = oldMsg.mode;
                    extra = oldMsg.extra;
                }
                if (this.useReplaceOld) {
                    this.replaceMsg(id, {
                        id: id,
                        dialogType: "bot",
                        msgType: aiResType.thinking,
                    });
                }
            }
            const msgId = this.useReplaceOld && id ? id : this.addBotMsg(aiResType.thinking);
            const extraParams = {
                extra,
            };
            Object.assign(extraParams, this.getSessionId());
            this.$emit("setTalkStatus", 3);
            const res = await this.aiResponse(str, mode, extraParams).catch((err) => {
                // task中断处理
                this.deleteMsg(msgId);
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("manulQuit") as string,
                });
            });
            if (res) {
                for (let i = this.msgList.length - 1; i >= 0; i--) {
                    if (this.msgList[i].id == msgId) {
                        let temp = {
                            id: this.msgId++,
                            dialogType: "bot",
                            msgType: res.msgType,
                            action: "echartTask",
                            aiStatus: this.aiStatus,
                            inputStr: str,
                            str: res.data,
                            toolList: res.toolList,
                            botUserInput: fileName,
                            extra,
                            mode,
                        };
                        this.deleteMsg(msgId);
                        this.pushMsg(temp);
                        this.pushHolidayText();
                        // this.replaceMsg(msgId, temp);
                        break;
                    }
                }
                this.scrollToBottom();
                this.$bus.$emit("refreshAIPoint", true);
            }
            this.$emit("toggleBan", false);
        }

        checkSocketStatus() {
            return this.initAiSocket();
        }
        taskReject = null;
        aiResponse(str, mode = "chat", extraParams?): Promise<{ msgType: number; data: string; toolList?: string[]; status?: string }> {
            let error = false;
            const handleResult = (s) => {
                const _view = window["_view"];
                const page = _view._activePage;
                if (error) {
                    return;
                }
                // console.log(this.resultText, '>>>>this.resultText')
                if (mode == "chat" && this.matchMode) {
                    // 匹配到关键词
                    s({
                        msgType: aiResType.text,
                        data: (this.$t("matchStr") as string).replace("%key%", this.matchMode.keyword),
                        toolList: ["btn"],
                    });
                } else if (this.aiStatus && this.aiStatusId > 0) {
                    // ai 分析
                    s({
                        msgType: aiResType.text,
                        data: this.resultText,
                        toolList: ["dropdown", "copy"],
                    });
                } else if (this.aiStatus) {
                    if (this.echartAiStatus) {
                        // echart制图
                        let type = mode.replace(/echart-/, "");
                        console.log(this.resultText);
                        this.aiInsertEchart(type)
                            .then(() => {
                                s({
                                    msgType: aiResType.text,
                                    data: this.$tc("echart-success"),
                                    toolList: ["refresh", "like"],
                                });
                            })
                            .catch(() => {
                                // 输出运行到一半的信息
                                this.msgEvent({
                                    action: "botMsg",
                                    msgType: aiResType.text,
                                    str: this.resultText,
                                });
                                s({
                                    msgType: aiResType.text,
                                    data: this.$tc("echart-fail"),
                                    toolList: ["refresh", "like"],
                                });
                            });
                    } else if (["pictureAnalysis", "chat", "textAnalysis"].includes(this.aiStatus)) {
                        // 图片分析、自由提问
                        s({
                            msgType: aiResType.text,
                            data: this.resultText,
                            toolList: ["like"],
                        });
                    } else if (this.aiStatus === "documentAnalysis") {
                        s({
                            msgType: aiResType.text,
                            data: this.resultText,
                            toolList: ["refresh", "copy"],
                        });
                    } else {
                        // ai 制图
                        this.aiCreateShape()
                            .then(() => {
                                s({
                                    msgType: aiResType.text,
                                    data: (this.$t("drawed") as string) + `【${this.$t(this.aiStatus)}】`,
                                    toolList: ["refresh", "like"],
                                });
                            })
                            .catch((msg) => {
                                s({
                                    msgType: aiResType.text,
                                    data: msg,
                                });
                            });
                    }
                } else if (mode == "flowchart-analyse") {
                    console.log(this.resultText);
                    const result = window["_view"].processFlowPrompt(this.resultText);
                    s({
                        msgType: aiResType.flowAnalysis,
                        data: result.join(),
                        toolList: ["like"],
                    });
                } else if (mode == "flowchart-explain") {
                    s({
                        msgType: aiResType.text,
                        data: this.resultText,
                        toolList: ["dropdown", "copy"],
                    });
                } else if (mode == "text-error-correction") {
                    s({
                        msgType: aiResType.textCheck,
                        data: this.resultText,
                        toolList: ["like"],
                    });
                } else if (mode == "flowchart-optimize-part") {
                    _view.generateFlow(page, this.resultText);
                    s({
                        msgType: aiResType.text,
                        data: (this.$t("flowchartCreated") as string).replace(/%key%/, this.flowTempWord),
                        toolList: ["like"],
                    });
                } else if (mode == "flowchart-optimize-supply") {
                    _view.generateFlow(page, this.resultText);
                    s({
                        msgType: aiResType.text,
                        data: (this.$t("flowchartCreated") as string).replace(/%key%/, this.flowTempWord),
                        toolList: ["like"],
                    });
                } else if (mode == "flowchart-optimize-add") {
                    _view.generateFlow(page, this.resultText);
                    s({
                        msgType: aiResType.text,
                        data: this.$t("drawed") as string,
                        toolList: ["like"],
                    });
                } else if (mode == "echart") {
                    this.aiInsertEchart()
                        .then(() => {
                            s({
                                msgType: aiResType.text,
                                data: this.$tc("echart-success"),
                                toolList: ["refresh", "like"],
                            });
                        })
                        .catch(() => {
                            // 输出运行到一半的信息
                            this.msgEvent({
                                action: "botMsg",
                                msgType: aiResType.text,
                                str: this.resultText,
                            });
                            s({
                                msgType: aiResType.text,
                                data: this.$tc("echart-fail"),
                                toolList: ["refresh", "like"],
                            });
                        });
                } else {
                    s({
                        msgType: aiResType.text,
                        data: this.resultText,
                        toolList: ["refresh", "dropdown", "copy"],
                    });
                }
                if (mode != "chat") {
                    // 逐字输出时此处无需清除reject
                    this.taskReject = null;
                }
            };
            const handleError = (s, e) => {
                this.taskReject = null;
                if (error) return;
                if (e == 2406) {
                    // 敏感词，暂不做处理
                } else if (e == 3000) {
                    s({
                        status: "error",
                        msgType: aiResType.textRefresh,
                        data: this.$t("httpError1") as string,
                    });
                } else if (e == 3001) {
                    s({
                        status: "error",
                        msgType: aiResType.textRefresh,
                        data: this.$t("httpError2") as string,
                    });
                } else {
                    s({
                        status: "error",
                        msgType: aiResType.textRefresh,
                        data: this.$t("httpError3") as string,
                    });
                }
            };
            return new Promise((s, j) => {
                this.taskReject = () => {
                    j();
                    error = true;
                    if (!this.aiDone) {
                        this.socketSend("uns");
                    }
                    this.taskReject = null;
                };
                this.inputText = str;
                if (this.$store.state.user.noLoginEditor) {
                    return this.generatingNologin(mode, extraParams)
                        .then(() => {
                            handleResult(s);
                        })
                        .catch((e) => {
                            handleError(s, e);
                        });
                } else {
                    this.checkSocketStatus().then(() => {
                        this.generating(mode, extraParams, mode == "chat" ? this.aiReceiveFunc : null)
                            .then(() => {
                                handleResult(s);
                            })
                            .catch((e) => {
                                handleError(s, e);
                            });
                    });
                }
            });
        }

        receiveStrList = [];
        receiveWorking = false;
        receiveWorkId = 0;
        receiveDoneCallback = null;
        aiReceiveFunc(newStr: string) {
            // 接收到ai消息时触发
            const updateMsg = (str: string) => {
                let id = this.msgId - 1; // 如useReplaceOld开启，此处需适配
                let temp = this.getMsg(id);
                temp.str += str;
                this.replaceMsg(id, temp);
                this.scrollToBottom();
            };
            const add = () => {
                this.receiveWorkId = requestAnimationFrame(() => {
                    if (this.receiveStrList.length != 0) {
                        updateMsg(this.receiveStrList.shift());
                        add();
                    } else {
                        this.receiveWorking = false;
                        this.receiveDoneCallback && this.receiveDoneCallback();
                        this.receiveDoneCallback = null;
                        this.taskReject = null;
                    }
                });
            };
            this.receiveStrList = this.receiveStrList.concat(newStr.split(""));
            !this.receiveWorking && add();
            this.receiveWorking = true;
        }
        cancelReceiveFrame() {
            cancelAnimationFrame(this.receiveWorkId);
            this.receiveWorking = false;
            this.receiveStrList = [];
            this.aiReceive = null;
        }

        aiCreateShape() {
            return new Promise((s, reject) => {
                const _view = window["_view"];
                const page = _view._activePage;
                // 生成流程图
                if (this.aiStatus == "flowchart") {
                    const parserObj = parseMermaidText(this.resultText);
                    if (parserObj?.vertices?.length > 0) {
                        _view.generateFlowFromMermaid(page, parserObj);
                    } else {
                        reject(this.$t("flowchart-error"));
                    }
                    // _view.generateFlow(page, this.resultText);
                }
                // 生成多级思维导图
                if (this.aiStatus == "mindmap") {
                    _view.generateMindMap(page, this.inputText, this.resultText);
                }
                // 生成列表
                if (this.aiStatus == "list") {
                    let textList = this.resultText.split("\n");
                    textList.unshift(this.inputText);
                    _view.generateListTemplate(page, textList);
                }
                // 生成表格
                if (this.aiStatus == "table") {
                    _view.generateForm(page, this.resultText);
                }
                if (["timeline", "swot", "canvas", "pest", "portrait", "story"].includes(this.aiStatus)) {
                    let mode = this.getMode();
                    s(_view.generateAIDraw(mode, this.resultText));
                } else {
                    s(true);
                }
            });
        }

        aiInsertEchart(type = "bar") {
            const getOption = () => {
                try {
                    JSON.parse(this.resultText);
                    return this.resultText;
                } catch (err) {
                    let temp = this.resultText.split("\n");
                    let list: Array<string> = [];
                    temp.forEach((str) => {
                        str = str.trim();
                        if (str) list.push(str);
                    });
                    let flag = false;
                    return list.reduce((p, c) => {
                        if (c == "```") {
                            flag = false;
                        } else if (c == "```json") {
                            flag = true;
                        } else if (flag) {
                            p += c;
                        }
                        return p;
                    }, "");
                }
            };
            const option = getOption();
            if (option) {
                this.$bus.$emit("aiCreateEchart", option, type);
                return Promise.resolve();
            } else {
                // echart data error
                return Promise.reject();
            }
        }

        flowchartTask(id = 0, str: string) {
            this.msgEvent({
                action: "botMsg",
                dialogType: "bot",
                msgType: aiResType.text,
                str: this.$t("flowAnalyseStr"),
            });
            this.addUserTask(id, str);
        }

        stopTask(showResultText = true) {
            if (this.msgMode == "chat") {
                this.cancelReceiveFrame();
                this.taskReject && this.taskReject();
                this.$emit("toggleBan", false);
                this.replaceMsg(this.msgId - 1, {
                    id: this.msgId - 1,
                    msgType: aiResType.text,
                    str: this.resultText,
                    dialogType: "bot",
                });
            } else if (this.taskReject) {
                if (this.resultText && showResultText) {
                    // 输出运行到一半的信息
                    this.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: this.resultText,
                    });
                }
                this.taskReject();
            } else {
                // 未触发请求时停止生成需手动关闭状态
                this.$emit("toggleBan", false);
            }
        }

        clickTemplateCase(id: number) {
            if (!this.agree) {
                this.$emit("handleShowAgree");
                return;
            }
            const msgType = [5, 6, 7][id];
            this.msgEvent({
                action: "botMsg",
                msgType: msgType,
            });
            this.scrollToBottom();
        }

        get analysisStr() {
            let temp = this.isSomeAnalysis ? "enterAnalysis" : !!this.aiStatusType ? "enter" : "enter1";
            const baseStr = this.$t(temp) as string;
            return baseStr.replace(/%label%/g, this.$t(this.aiStatus) as string);
        }

        get isSomeAnalysis() {
            return ["pictureAnalysis", "documentAnalysis", "textAnalysis"].includes(this.aiStatus);
        }

        addedSysMsgForPictureAnalysis = false;
        aiStatus = null;
        aiStatusId = -1;
        aiStatusType = "";
        clickImglist(obj: { type: string; id: number; label: string }) {
            if (!this.agree) {
                this.$emit("handleShowAgree");
                return;
            }
            if (!obj) return;
            let { type, id, label } = obj;
            if (label !== "pictureAnalysis") {
                this.addedSysMsgForPictureAnalysis = false;
            }
            if (this.aiStatus === label) {
                let sysPreset = this.isSomeAnalysis ? "drawingAnalysis" : "drawing";

                const baseStr = this.$t(sysPreset) as string;
                if (this.aiStatus === "pictureAnalysis") {
                    if (this.addedSysMsgForPictureAnalysis) {
                        return;
                    }
                    this.addedSysMsgForPictureAnalysis = true;
                }
                this.msgEvent({
                    action: "sysMsg",
                    str: baseStr.replace(/%label%/g, this.$t(this.aiStatus) as string),
                });
                return;
            }
            this.$emit("setTalkStatus", 2);
            if (this.aiStatus) {
                this.msgEvent({
                    action: "sysMsg",
                    str: this.getQuitMsg(),
                });
            }
            this.aiStatus = label;
            this.aiStatusType = type;
            if (this.isSomeAnalysis) {
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t(type),
                });
                this.$emit("toggleAIStatus", this.aiStatus);
                return;
            }

            const getUserMsg = () => {
                const drawStr = this.$t("draw") as string;
                return drawStr.replace(/%1/g, this.$t(this.aiStatus) as string);
            };
            const getEnterMsg = () => {
                let sysPreset = this.isSomeAnalysis ? "enterAnalysis" : "enter";
                const baseStr = this.$t(sysPreset) as string;
                return baseStr.replace(/%label%/g, this.$t(this.aiStatus) as string);
            };
            this.msgEvent({
                action: "sysMsg",
                str: getEnterMsg(),
            });
            this.msgEvent({
                action: "userMsg",
                str: getUserMsg(),
                order: "",
            });
            const getBotMsg = () => {
                if (type == "echart") {
                    return this.$tc("echart-inputtips").replace(/%label%/g, this.$t(this.aiStatus) as string);
                }
                const baseStr = this.$t("example") as string;
                return baseStr.replace(/%label%/g, this.$t(this.aiStatus) as string);
            };
            this.msgEvent({
                action: "botMsg",
                msgType: aiResType.example,
                str: getBotMsg(),
                order: "",
                callback: () => {
                    let result = "";
                    const hotShapeData = [
                        this.$t("hotshape-flowchart"),
                        this.$t("hotshape-mindmap"),
                        this.$t("hotshape-table"),
                        this.$t("hotshape-list"),
                        this.$t("hotshape-timeline"),
                    ];
                    const marketData = [this.$t("market-swot"), this.$t("market-pest"), this.$t("market-canvas")];
                    const userData = [this.$t("user-portrait"), this.$t("user-story")];
                    const echartData = [
                        this.$t("echart-line"),
                        this.$t("echart-bar"),
                        this.$t("echart-pie"),
                        this.$t("echart-scatter"),
                        this.$t("echart-candlestick"),
                        this.$t("echart-radar"),
                        this.$t("echart-boxplot"),
                        this.$t("echart-heatmap"),
                        this.$t("echart-graph"),
                        this.$t("echart-sunburst"),
                        this.$t("echart-parallel"),
                        this.$t("echart-sankey"),
                        this.$t("echart-funnel"),
                        this.$t("echart-gauge"),
                    ];
                    if (type == "hotShape") {
                        result = hotShapeData[id] as string;
                    } else if (type == "market") {
                        result = marketData[id] as string;
                    } else if (type == "user") {
                        result = userData[id] as string;
                    } else if (type == "echart") {
                        result = echartData[id] as string;
                    } else {
                        result = (this.$t("drawTip") as string).replace(/%label%/g, this.$t(this.aiStatus) as string);
                    }
                    this.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: result,
                        toolList: ["copy"],
                    });
                },
            });
            this.$emit("toggleAIStatus", this.aiStatus);
        }

        cleanStatus(show = true) {
            if (this.aiStatus) {
                // 如存在预置类型，清除并输出退出提示
                this.$emit("toggleAIStatus", "chat");
                this.$nextTick(() => {
                    if (show) {
                        this.msgEvent({
                            action: "sysMsg",
                            str: this.getQuitMsg(),
                        });
                    }
                    this.aiStatus = null;
                    this.aiStatusType = null;
                    this.aiStatusId = 0;
                });
                if (this.taskReject) {
                    // 退出时中断任务
                    this.taskReject();
                }
            }
        }
        @Watch("shapeId")
        quitStatus(nv, ov) {
            if (nv != ov && this.aiStatusId > 0 && !this.isPictureTask && !this.isInternalAndTextAnalysis) {
                this.cleanStatus();
            }
        }

        changeStatus(data: string, id: number = 0, aiStatusType = null) {
            this.aiStatus = data;
            this.aiStatusId = id;
            this.aiStatusType = aiStatusType;
            this.$emit("setAnalyseId", this.aiStatusId);
            this.$emit("toggleAIStatus", this.aiStatus);
        }

        clickRefresh({ id, inputStr, action, aiStatus }) {
            let msg = this.getMsg(id);
            let aiStatusId = 0;
            if (msg.action == "aiAnalyse") {
                aiStatusId = msg.aiStatusId;
            }
            if (msg.hasOwnProperty("recg_kw_onceFlag")) {
                this.recg_kw_onceFlag = msg.recg_kw_onceFlag;
            }
            if (msg.inputStr && msg.action == "userTask") {
                this.msgEvent({
                    action: "userMsg",
                    str: msg.inputStr,
                });
            }
            this.changeStatus(aiStatus, aiStatusId, msg.aiStatusType || null);
            if (msg.imgDatas) {
                this.msgEvent({
                    id,
                    action,
                    str: inputStr,
                    imgDatas: msg.imgDatas,
                });
            } else {
                this.msgEvent({
                    id,
                    action,
                    str: inputStr,
                });
            }

            this.$emit("toggleBan", true);
        }

        rejectStatus = false;
        msgEvent(obj: any) {
            console.log("talkStatus", this.talkStatus);
            if (!this.agree) {
                this.$emit("handleShowAgree");
                return;
            }
            if (this.rejectStatus) return;
            let {
                id,
                action,
                str,
                order,
                msgType,
                key,
                fileName,
                fileType,
                extra,
                localImg,
                shapeStr,
                callback,
                toolList,
                botUserInput,
                pictures,
                imgDatas,
                mode,
            } = obj;
            if (action == "userTask" && this.aiStatusId > 0) {
                // 分析形状状态下对话，切换为ai分析事件
                action = "aiAnalyse";
                shapeStr = window["_view"].getShapeMarkdownData();
            }
            const map = new Map([
                [
                    "userTask",
                    () => {
                        this.addUserTask(id, str);
                    },
                ],
                [
                    "flowchartTask",
                    () => {
                        this.flowchartTask(id, str);
                    },
                ],
                [
                    "userMsg",
                    () => {
                        this.addUserMsg(str, msgType, fileName, fileType);
                    },
                ],
                [
                    "userMsgForPicture",
                    () => {
                        this.addUserMsgForPicture(str, msgType, pictures);
                    },
                ],
                [
                    "botMsg",
                    () => {
                        this.addBotMsg(msgType, str, order, localImg, callback, toolList);
                    },
                ],
                [
                    "sysMsg",
                    () => {
                        this.addSysMsg(str);
                    },
                ],
                [
                    "clickTag",
                    () => {
                        this.addTagMsg(key, str);
                    },
                ],
                [
                    "presetTag",
                    () => {
                        this.presetTag(id, str, botUserInput);
                    },
                ],
                [
                    "textCheck",
                    () => {
                        this.aiTextCheck(id, str);
                    },
                ],
                [
                    "fileTask",
                    () => {
                        this.extraTask(id, str, extra, fileName);
                    },
                ],
                [
                    "aiAnalyse",
                    () => {
                        this.aiAnalyseTask(id, str, shapeStr);
                    },
                ],
                [
                    "flowAnalyse",
                    () => {
                        this.flowchartAnalyse(id, str, shapeStr, imgDatas);
                    },
                ],
                [
                    "echartTask",
                    () => {
                        this.extraEchartTask(id, str, extra, shapeStr);
                    },
                ],
                [
                    "pictureTask",
                    () => {
                        this.pictureTask(id, str, extra, imgDatas, mode);
                    },
                ],
            ]);
            map.has(action) && map.get(action)();
        }

        aiClickImgEvent(key) {
            let obj = {
                flowchart: { type: "hotShape", id: 0, label: "flowchart" },
                mindmap: { type: "hotShape", id: 1, label: "mindmap" },
                table: { type: "hotShape", id: 2, label: "table" },
                list: { type: "hotShape", id: 3, label: "list" },
                timeline: { type: "hotShape", id: 4, label: "timeline" },
                swot: { type: "market", id: 0, label: "swot" },
                pest: { type: "market", id: 1, label: "pest" },
                canvas: { type: "market", id: 2, label: "canvas" },
                portrait: { type: "user", id: 0, label: "portrait" },
                story: { type: "user", id: 1, label: "story" },
                line: { type: "echart", id: 0, label: "line" },
                bar: { type: "echart", id: 1, label: "bar" },
                pie: { type: "echart", id: 2, label: "pie" },
                scatter: { type: "echart", id: 3, label: "scatter" },
                candlestick: { type: "echart", id: 4, label: "candlestick" },
                radar: { type: "echart", id: 5, label: "radar" },
                boxplot: { type: "echart", id: 6, label: "boxplot" },
                heatmap: { type: "echart", id: 7, label: "heatmap" },
                graphChart: { type: "echart", id: 8, label: "graphChart" },
                sunburst: { type: "echart", id: 9, label: "sunburst" },
                parallel: { type: "echart", id: 10, label: "parallel" },
                sankey: { type: "echart", id: 11, label: "sankey" },
                funnel: { type: "echart", id: 12, label: "funnel" },
                gauge: { type: "echart", id: 13, label: "gauge" },
                pictureAnalysis: { type: "pictureAnalysisText", label: "pictureAnalysis" },
                documentAnalysis: { type: "documentAnalysisText", label: "documentAnalysis" },
                textAnalysis: { type: "textAnalysisText", label: "textAnalysis" },
            };
            this.clickImglist(obj[key]);
        }
        get echartAiStatus() {
            return [
                "line",
                "bar",
                "pie",
                "scatter",
                "candlestick",
                "radar",
                "boxplot",
                "heatmap",
                "graphChart",
                "sunburst",
                "parallel",
                "sankey",
                "funnel",
                "gauge",
            ].includes(this.aiStatus);
        }

        aiTextCheckEvent(str: string) {
            if (!this.agree) {
                this.$emit("handleShowAgree");
                return;
            }
            this.cleanStatus(false);
            this.msgEvent({
                action: "botMsg",
                msgType: aiResType.text,
                str: this.$t("textCheck") as string,
            });
            this.msgEvent({
                action: "textCheck",
                str,
            });
        }

        displayCheck() {
            // 右侧面板展开后触发
            let list: any[] = this.$refs.msgItemList as any;
            if (!list) return;
            for (let item of list) {
                if (item.msgType == "botMsg") item.setUnderLine();
            }
        }

        clickToolBtn(data) {
            const { id, type } = data;
            let temp = this.getMsg(id);
            temp.toolList = [];
            this.replaceMsg(id, temp);
            if (type) {
                let modeFit = null;
                const map = new Map();
                map.set("flowchart", "flowchart");
                map.set("mindmap-md", "mindmap");
                map.set("form", "table");
                map.set("list", "list");
                map.set("timeline", "timeline");
                map.set("swot", "swot");
                map.set("leanCanvas", "canvas");
                map.set("pest", "pest");
                map.set("userProfile", "portrait");
                map.set("userStory", "story");
                if (map.has(this.matchMode.mode)) {
                    modeFit = map.get(this.matchMode.mode);
                    this.aiClickImgEvent(modeFit);
                } else {
                    modeFit = null;
                    this.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: this.$t("modeUnsupport"),
                    });
                }
            } else {
                this.msgEvent({
                    action: "userMsg",
                    str: this.$t("no"),
                });
                this.recg_kw_onceFlag = false; // 临时关闭chat识别关键字模式，一次请求后自动恢复
                this.msgEvent({
                    action: "userTask",
                    str: temp.inputStr,
                });
            }
            this.matchMode = null;
        }

        aiAnalyseMap = null;
        getAiAnalyseMap() {
            if (this.aiAnalyseMap) return;
            this.aiAnalyseMap = new Map();
            const getShapeType = (str) => {
                if (/gantt/.test(str)) return "gantt";
                if (/flowchart/.test(str)) return "flowchart";
                if (/graph/.test(str)) return "graph";
                if (/org/.test(str)) return "org";
            };
            for (let item in aiStatusType) {
                let num = parseInt(item);
                if (num > 0) {
                    let data = getShapeType(aiStatusType[item]);
                    this.aiAnalyseMap.set(num, data);
                } else {
                    break;
                }
            }
        }
        get isInternalAndTextAnalysis() {
            return this.internal && this.aiStatus === "textAnalysis";
        }
        get shapeType() {
            return this.$store.state.shape.type;
        }
        getQuitMsg() {
            let temp = this.isSomeAnalysis ? "quitAnalysis" : !!this.aiStatusType ? "quit" : "quit1";
            const baseStr = this.$t(temp) as string;
            return baseStr.replace(/%label%/g, this.$t(this.aiStatus) as string);
        }
        aiAnalyseTempUserInput = "";
        aiAnalyseEvent(id: number, userStr: string, onlyChangeStatus = false) {
            if (!this.agree) {
                this.$emit("handleShowAgree");
                return;
            }
            this.getAiAnalyseMap();
            console.log(this.aiAnalyseMap, id);
            let key = this.aiAnalyseMap.get(id);
            if (this.shapeType == "Table") {
                key = "table";
            }
            if (key == "graph" || key === "org" || key === "gantt" || key === "flowchart" || key === "table") {
                key = "pictureAnalysis";
            }
            if (this.internal && key === "pictureAnalysis") {
                key = "textAnalysis";
            }

            const isSame = this.aiStatus === key;

            if (this.aiStatus && !isSame) {
                this.msgEvent({
                    action: "sysMsg",
                    str: this.getQuitMsg(),
                });
            }
            this.changeStatus(key, id);

            const getEnterMsg = () => {
                let sysPreset = this.isSomeAnalysis ? "enterAnalysis" : "enter1";
                const baseStr = this.$t(sysPreset) as string;
                return baseStr.replace(/%label%/g, this.$t(this.aiStatus) as string);
            };
            const getDrawingMsg = () => {
                let sysPreset = this.isSomeAnalysis ? "drawingAnalysis" : "drawing1";
                const baseStr = this.$t(sysPreset) as string;
                return baseStr.replace(/%label%/g, this.$t(this.aiStatus) as string);
            };
            if (!isSame) {
                this.msgEvent({
                    action: "sysMsg",
                    str: getEnterMsg(),
                });
            } else if (onlyChangeStatus) {
                this.msgEvent({
                    action: "sysMsg",
                    str: getDrawingMsg(),
                });
            }

            if (!onlyChangeStatus) {
                this.aiAnalyseTempUserInput = userStr;
                this.msgEvent({
                    action: "userMsg",
                    str: userStr,
                    order: "",
                });

                // 甘特图、图表/表格、组织结构图走图片分析流程
                if (key === "pictureAnalysis") {
                    window["_view"].generateActiveDiagramBitmap(async (blob) => {
                        if (!blob) {
                            this.$edMessage.error(this.$t("unselect-shape-error"));
                            return;
                        }

                        const maxSize = 20 * 1024 * 1024; // 20M
                        if (blob.size > maxSize) {
                            this.$edMessage.error(this.$t("image-size-error"));
                            return;
                        }

                        const reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onload = (e) => {
                            const src = e?.target?.result;
                            this.msgEvent({
                                action: "pictureTask",
                                str: userStr,
                                imgDatas: [
                                    {
                                        mime_type: "image/jpeg",
                                        data: (src as string)?.split(",")?.[1], // Base64
                                    },
                                ],
                                mode: analyseModeMap.get(id),
                            });
                        };
                    });
                } else {
                    const str = window["_view"].getShapeMarkdownData();
                    this.msgEvent({
                        action: "aiAnalyse",
                        str: "",
                        shapeStr: str,
                    });
                }

                this.$emit("toggleBan", true);
            }
        }

        // 流程图分析
        flowAnalyseId = 0;
        flowTempWord = "";
        flowAnalyseEvent(id, displayStr = "") {
            if (!this.agree) {
                this.$emit("handleShowAgree");
                return;
            }
            this.cleanStatus(false);
            if ([aiStatusType.flowchartAnalyse, aiStatusType.flowchartExplain].includes(id)) {
                // 流程图分析，流程图说明
                if (id == aiStatusType.flowchartExplain) {
                    this.aiAnalyseTempUserInput = this.$t("flowchartExplain") as string;
                }
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: this.$t("flowAnalyseStr"),
                });
                this.flowAnalyseId = id;
                const str = window["_view"].getFlowPrompt();
                if (!str[0]) {
                    this.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: this.$t("flowchartNotSelect") as string,
                    });
                    return;
                }
                this.msgEvent({
                    action: "flowAnalyse",
                    str: str,
                });

                this.$emit("toggleBan", true);
            } else if (id == aiStatusType.flowchartOptimize) {
                this.addBotMsg(aiResType.flowImprove);
            } else if ([aiStatusType.flowchartOptimizePart, aiStatusType.flowchartOptimizeSupply].includes(id)) {
                this.flowTempWord = displayStr;
                this.flowAnalyseId = id;
                this.msgEvent({
                    action: "userMsg",
                    str: displayStr,
                });
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: (this.$t("flowchartCreating") as string).replace(/%key%/, displayStr),
                });
                const str = window["_view"].getFlowPrompt();
                console.log(str);
                if (!str[0]) {
                    this.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: this.$t("flowchartNotSelect") as string,
                    });
                    return;
                }
                this.msgEvent({
                    action: "flowAnalyse",
                    str,
                });
                this.$emit("toggleBan", true);
            } else if (aiStatusType.flowchartOptimizeAdd == id) {
                this.flowAnalyseId = id;
                this.msgEvent({
                    action: "userMsg",
                    str: displayStr,
                });
                this.msgEvent({
                    action: "botMsg",
                    msgType: aiResType.text,
                    str: `${this.$t("addFlowchartTips1")}\n${this.$t("addFlowchartTips2")}`,
                });
                this.$emit("setFlowchartCheck");
            }
        }

        // AI4.0流程图分析
        flowAnalyseEventV4(id, displayStr = "") {
            if (!this.agree) {
                this.$emit("handleShowAgree");
                return;
            }

            window["_view"].generateActiveFlowBitmap(async (blob) => {
                if (!blob) {
                    this.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: this.$t("flowchartNotSelect") as string,
                    });
                    return;
                }

                const maxSize = 20 * 1024 * 1024; // 20M
                if (blob.size > maxSize) {
                    this.$edMessage.error(this.$t("image-size-error"));
                    return;
                }

                // const domain = urls.edrawmaxApi;
                // const url = `https://${domain}/api/ai/v1/upload/vision`;
                // const formData = new FormData();
                // formData.append("file", blob);
                // const res = await axios.post(url, formData, {
                //     headers: {
                //         Authorization: "Bearer " + this.userInfo.token,
                //     },
                // });
                // const imgLink = (res && res.data && res.data.data && res.data.data.img_link) || "";

                // if (imgLink === "") {
                //     this.$edMessage.error(this.$t("upload-image-fail"));
                //     return;
                // }

                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = (e) => {
                    const src = e?.target?.result;
                    this.aiStatus = "pictureAnalysis";
                    this.aiStatusType = null;
                    this.$emit("toggleAIStatus", "pictureAnalysis");
                    this.flowAnalyseId = id;
                    this.msgEvent({
                        action: "userMsg",
                        str: displayStr,
                    });

                    this.msgEvent({
                        action: "flowAnalyse",
                        str: displayStr,
                        imgDatas: [
                            {
                                mime_type: "image/jpeg",
                                data: (src as string)?.split(",")?.[1], // Base64
                            },
                        ],
                    });
                };
            });
        }

        // 进入ai问答
        firstEnter = true;
        aichatEvent() {
            if (this.aiStatus || this.aiStatusId > 0 || this.firstEnter) {
                this.firstEnter = false;
                this.cleanStatus();
                this.$nextTick(() => {
                    this.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: this.$t("aiChatEnter"),
                    });
                });
            } else {
                this.msgEvent({
                    action: "sysMsg",
                    str: this.$t("aiChatStatus"),
                });
            }
        }

        addUserMsgFromOutside(str) {
            this.msgEvent({
                action: "userMsg",
                str: str,
            });
        }

        aiMsgEventFromOutside(obj) {
            this.msgEvent(obj);
        }
        aiTextMoreEvent() {
            this.aiStatus = "textAnalysis";
            this.aiStatusType = null;
            this.$emit("toggleAIStatus", "textAnalysis");
        }

        offlineHandler() {
            this.stopTask();
            window["_view"]?.AISelTool();
        }

        mounted() {
            // this.changeStatus("流程图分析", aiStatusType.flowchart) // for test
            // this.addBotMsg(aiResType.preset);
            // this.addBotMsg(aiResType.flowImprove);
            // this.addBotMsg(aiResType.textCheck);
            this.$bus.$on("aiClickImglist", this.aiClickImgEvent);
            this.$bus.$on("aiTextCheck", this.aiTextCheckEvent);
            this.$bus.$on("aiAnalyse", this.aiAnalyseEvent);
            this.$bus.$on("aiFlowAnalyse", this.internal ? this.flowAnalyseEvent : this.flowAnalyseEventV4);
            this.$bus.$on("aiChat", this.aichatEvent);
            this.$bus.$on("addMsgListUserMsg", this.addUserMsgFromOutside);
            this.$bus.$on("aiMsgEvent", this.aiMsgEventFromOutside);
            this.$bus.$on("aiTextMore", this.aiTextMoreEvent);
            window.addEventListener("offline", this.offlineHandler);
            // window.onoffline = () => {}
        }

        created() {
            // this.initAiSocket();
        }

        beforeDestroy() {
            this.$bus.$off("aiClickImglist", this.aiClickImgEvent);
            this.$bus.$off("aiTextCheck", this.aiTextCheckEvent);
            this.$bus.$off("aiAnalyse", this.aiAnalyseEvent);
            this.$bus.$off("aiFlowAnalyse", this.internal ? this.flowAnalyseEvent : this.flowAnalyseEventV4);
            this.$bus.$off("aiChat", this.aichatEvent);
            this.$bus.$off("addMsgListUserMsg", this.addUserMsgFromOutside);
            this.$bus.$off("aiMsgEvent", this.aiMsgEventFromOutside);
            this.$bus.$off("aiTextMore", this.aiTextMoreEvent);
            window.removeEventListener("offline", this.offlineHandler);
        }
    }
</script>
<i18n>
{
    "zh": {
        "aiName": "亿图AI",
        "draw": "我要绘制%1",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "本次生成已手动停止",
        "enter": "已进入<b> %label%绘制 </b>模式",
        "enter1": "已进入<b> %label%分析 </b>模式",
        "enterAnalysis": "已进入<b> %label% </b>模式",
        "drawing": "目前您已在<b> %label%绘制 </b>模式中",
        "drawing1": "目前您已在<b> %label%分析 </b>模式中",
        "drawingAnalysis": "目前您已在<b> %label% </b>模式中",
        "quit": "已退出<b> %label%绘制 </b>模式",
        "quit1": "已退出<b> %label%分析 </b>模式",
        "quitAnalysis":  "已退出<b> %label% </b>模式",
        "example": "好的，请问您要绘制什么主题的%label%",
        "flowchart": "流程图",
        "mindmap": "思维导图",
        "table": "表格",
        "list": "列表",
        "timeline": "时间线",
        "swot": "SWOT分析",
        "pest": "PEST分析",
        "canvas": "精益画布",
        "story": "用户故事",
        "portrait": "用户画像",
        "gantt": "甘特图",
        "graph": "图表",
        "org": "组织架构图",

        "line": "折线图",
        "bar": "柱状图",
        "pie": "饼图",
        "scatter": "散点图",
        "candlestick": "K线图",
        "radar": "雷达图",
        "boxplot": "盒须图",
        "heatmap": "热力图",
        "graphChart": "关系图",
        "sunburst": "旭日图",
        "parallel": "平行坐标系",
        "sankey": "桑基图",
        "funnel": "漏斗图",
        "gauge": "仪表盘",

        "pictureAnalysis": "图片分析",
        "documentAnalysis": "文件分析",
        "textAnalysis": "文本分析",
        "pictureAnalysisText": "你想要分析什么图片，可以通过上传图片按钮上传分析",
        "documentAnalysisText": "你可以通过上传文件按钮，上传文件并分析",
        "textAnalysisText": "请从画布中选择文本进行分析。",
        "role-realtionships": "人物关系图",
        "drawed": "已在画布中生成",
        "hotshape-flowchart": "案例：生成人力资源招聘的流程。不少于10个步骤，开始于发布职位信息，结束于发放Offer。包含但不限于筛选简历、安排面试、背景调查、制定薪酬等步骤。",
        "hotshape-mindmap": "案例：生成一款环保产品的头脑风暴，产品应当解决一个现有的环境问题，例如塑料污染、水资源短缺等。可以考虑使用可持续材料、减少废弃物等实现这个目标，需要提供具体的设计方案和功能描述。",
        "hotshape-table": "案例：生成2022新能源汽车销量表，包含车辆类型（电动汽车或或者动力汽车）、品牌、月份等信息的售出总单位数，并按照类型和国家进行区分。",
        "hotshape-list": "案例：生成维护客户关系技巧的列表，需要包括如何建立和维护良好的客户关系，并通过如何处理投诉和问题，提供客户满意度这一维度进行展示5个通用技巧和2个关键技巧。",
        "hotshape-timeline": "案例：生成互联网发展的时间线，时间线范围为2000年到2023年。",
        "market-swot": "案例：外卖行业的SWOT分析",
        "market-pest": "案例：新能源汽车的市场环境分析",
        "market-canvas": "案例：迪士尼的商业模式分析",
        "user-story": "案例：线上打车用户故事地图",
        "user-portrait": "案例：平板电脑的用户画像",
        "textCheck": "文本检查中，为了不放过任何的蛛丝马迹，请耐心等待。",
        "matchStr": "请问您是否需要绘制%key%",
        "flowchartExplain": "流程图说明",
        "flowAnalyseStr": "正在快马加鞭地为您分析选中部分的流程图，请耐心等待。",
        "flowchartCreating": "好的，正在%key%",
        "flowchartNotSelect": "请先在画布上选择流程图形状，再进行操作",
        "flowchartCreated": "已在画布上完成【%key%】",
        "addFlowchartTips1": "好的，您可以参考以下案例告诉我应该如何新增。",
        "addFlowchartTips2": "例：在【XXX】后面新增一个【XXX】的流程。",
        "modeUnsupport": "非常抱歉，暂时无法绘制该图形。请点击底部的一键制图按钮，查看我们支持绘制的图形。感谢您的理解和支持。",
        "aiChatEnter": "欢迎进入AI问答，请在底部输入框输入您想问的问题。",
        "aiChatStatus": "目前您已在AI问答模式中",
        "httpError1": "AI点数不足",
        "httpError2": "服务器繁忙，请稍后重试",
        "httpError3": "网络错误...AI接口无数据返回",
        "cleanStatus": "退出",
        "no": "否",
        "echart-line": "案例：显示从2010年到2020年，每年的全球平均温度变化。",
        "echart-bar": "案例：对比2023年世界人口前5的国家人口数量。",
        "echart-pie": "案例：展示一个公司的预算分配，包括研发、销售、运营等部门。",
        "echart-scatter": "案例：根据身高和体重的数据，描绘出一张成年人的BMI分布图。",
        "echart-candlestick": "案例：展示苹果公司最近30天的股票价格走势，包括每天的开盘价、收盘价、最高价和最低价。",
        "echart-radar": "案例：对比2023年的五个最大汽车制造商在销量、利润、市场份额、客户满意度和环保等方面的表现。",
        "echart-boxplot": "案例",
        "echart-heatmap": "案例：展示一个周的网站访问量，横坐标为一天中的时间（24小时），纵坐标为周一到周日。",
        "echart-graph": "案例：显示一个社交网络的关系图，节点代表人，边代表他们之间的关系。",
        "echart-sunburst": "案例",
        "echart-parallel": "案例：对比几种酒的多个特性，包括酒精度、酸度、甜度等。",
        "echart-sankey": "案例：描绘一个城市的能源流向，从产生、分配到使用。",
        "echart-funnel": "案例：显示一个网站用户的购物行为漏斗，从访问网站、搜索产品、添加购物车、到最后的购买。",
        "echart-gauge": "案例：展示当前的CPU使用率，从0%到100%。",
        "echart-success": "图像已生成，请到画布中查看",
        "echart-fail": "图表生成失败。请更换提示词或重新上传数据。",
        "echart-inputtips": "你可以点击上传文件生成图表，也可以直接输入你想要的图表简介生成图表",
        "unselect-shape-error": "请先选择图形，再进行操作",
        "upload-image-fail": "图片上传失败",
        "image-size-error": "图片大小不能超过20M",
        "flowchart-error": "很抱歉，由于本次绘图未能成功完成，相应的AI点数已经返还至您的账户。请您再次尝试进行绘图。",
        "suggest-tip": "你可能还想问："
    },
    "en": {
        "aiName": "Edraw AI",
        "draw": "I want to draw a %1",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "Generation stopped.",
        "enter": "Entered<b> %label% </b>Mode",
        "enter1": "Entered<b> %label% Analysis </b>Mode",
        "enterAnalysis": "Entered<b> %label% </b>Mode",
        "drawing": "You are currently in<b> %label% </b>mode",
        "drawing1": "You are currently in<b> %label% analysis </b>mode",
        "drawingAnalysis": "You are currently in<b> %label%  </b>mode",
        "quit": "Exited<b> %label% </b>Mode",
        "quit1": "Exited<b> %label% Analysis </b>Mode",
        "quitAnalysis":  "Exited<b> %label% </b>Mode",
        "example": "OK. What subject would you like your %label% to be about?",
        "flowchart": "Flowchart",
        "mindmap": "Mind Map",
        "table": "Table",
        "list": "List",
        "timeline": "Timeline",
        "swot": "SWOT Analysis",
        "pest": "PEST Analysis",
        "canvas": "Lean Canvas",
        "story": "User Story",
        "portrait": "User Profile",
        "gantt": "Gantt",
        "graph": "Graph",
        "org": "Orgchart",
        "line": "Line Chart",
        "bar": "Bar Chart",
        "pie": "Pie Chart",
        "scatter": "Scatter Plot",
        "candlestick": "Candlestick Chart",
        "radar": "Radar Chart",
        "boxplot": "Box Plot",
        "heatmap": "Heat Map",
        "graphChart": "Relational Graph",
        "sunburst": "Sunburst Chart",
        "parallel": "Parallel Coordinates",
        "sankey": "Sankey Diagram",
        "funnel": "Funnel Chart",
        "gauge": "Dial",

        "pictureAnalysis": "Picture Analysis",
        "documentAnalysis": "Document Analysis",
        "textAnalysis": "Text Analysis",
        "pictureAnalysisText": "What picture would you like to analyze? You can upload the picture by clicking on the picture upload  button.",
        "documentAnalysisText": "What file would you like to analyze?  You can upload the file by clicking on the file upload button.",
        "textAnalysisText": "Select text on the canvas and ask me to analysis.",
        "role-realtionships": "人物关系图",
        "drawed": "Generated on the canvas",
        "hotshape-flowchart": "Example: Generate a HR recruitment process. There should be more than 10 steps, starting from publishing information about the role and ending with issuing an offer. The steps should include but are not limited to filtering resumes, arranging interviews, carrying out background checks, and determining the salary. ",
        "hotshape-mindmap": "Example: Generate a brainstorm for an eco-friendly product which should solve an existing environmental problem, such as plastic pollution or water shortages. You can consider using sustainable materials and reducing waste to achieve this goal, and specific design plans and feature descriptions must be provided. ",
        "hotshape-table": "Example: Generate a new energy vehicle sales table for 2022, including the number of units sold, as well as information such as vehicle type (electric or hybrid), brand, and month, and categorize by type and country. ",
        "hotshape-list": "Example: Generate a list of tips for maintaining client relationships. It must include how to build and maintain a good client relationship, how to handle complaints and problems, as well as five general skills and two key skills for providing client satisfaction. ",
        "hotshape-timeline": "Example: Generate a timeline of the development of the Internet from 2000 to 2023. ",
        "market-swot": "Example: A SWOT analysis of the takeout industry ",
        "market-pest": "Example: An analysis of the new energy vehicle market environment ",
        "market-canvas": "Example: Analyze Disney's business model",
        "user-story": "Example: Online taxi user story map ",
        "user-portrait": "Example: A tablet user profile ",
        "textCheck": "Please bear with us while your text is being reviewed.",
        "flowchartExplain": "Flowchart description",
        "matchStr": "Are you sure you want to generate a %key%?",
        "flowAnalyseStr": "I'm analyzing your selected flow chart as fast as I can. Please bear with me.",
        "flowchartCreating": "OK, %key%",
        "flowchartNotSelect": "Please first select the flowchart shape on the canvas before proceeding",
        "flowchartCreated": "[%key%] complete.",
        "addFlowchartTips1": "OK, see the following example to directly send a chat telling me how to supplement it. ",
        "addFlowchartTips2": "Example: Add a [Verify Account Information Process] after [Register User Account].",
        "modeUnsupport": "Sorry, Edraw AI does not support this type of diagram currently. Please click the AI Diagramming button at the bottom to see the diagrams Edraw AI supports. Thank you for your understanding.",
        "aiChatEnter": "Welcome to AI Q&A. Please input the question you want to ask in the input box at the bottom.",
        "aiChatStatus": "You are currently in AI Q&A status.",
        "httpError1": "Insufficient ai points",
        "httpError2": "Please try again later",
        "httpError3": "Network error. No data returned from the AI interface",
        "cleanStatus": "Exit",
        "no": "No",
        "echart-line": "Example: Display the global average temperature changes every year from 2010 to 2020.",
        "echart-bar": "Example: Compare the population sizes of the top 5 countries in the world in 2023.",
        "echart-pie": "Example: Show the budget allocation of a company, including departments like R&D, sales, and operations.",
        "echart-scatter": "Example: Draw a BMI distribution chart for adults based on height and weight data.",
        "echart-candlestick": "Example: Show the stock price trend of Apple Inc. over the past 30 days, including the daily opening price, closing price, highest price, and lowest price.",
        "echart-radar": "Example: Compare the performance of the top five car manufacturers in 2023 in terms of sales, profits, market share, customer satisfaction, and environmental friendliness.",
        "echart-boxplot": "案例",
        "echart-heatmap": "Example: Show the website visits for a week, with the x-axis representing the time of the day (24 hours) and the y-axis representing Monday to Sunday.",
        "echart-graph": "Example: Display a social network graph, where nodes represent individuals and edges represent relationships between them.",
        "echart-sunburst": "案例",
        "echart-parallel": "Example: Compare several characteristics of different wines, including alcohol content, acidity, sweetness, etc.",
        "echart-sankey": "Example: Depict the energy flow of a city, from generation, distribution to use.",
        "echart-funnel": "Example: Show a website user's shopping behavior funnel, from visiting the website, searching for products, adding to the shopping cart, to the final purchase.",
        "echart-gauge": "Example: Display the current CPU usage rate, from 0% to 100%.",
        "echart-success": "Chart generated on canvas",
        "echart-fail": "Chart generation failed. Please try other prompt or upload new data file.",
        "echart-inputtips": "You can upload files to generate charts, or you can directly input the description of the chart you want to generate.",
        "unselect-shape-error": "Please select a shape first, then proceed with the operation.",
        "upload-image-fail": "Image upload failed.",
        "image-size-error": "The size of the image cannot exceed 20MB.",
        "flowchart-error": "Sorry, the drawing failed. The AI Points have been returned to your account. Please try drawing again.",
        "suggest-tip": "You might also want to ask:"
    },
    "fr": {
        "aiName": "IA Edraw",
        "draw": "Je veux dessiner %1",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "Génération arrêtée manuellement",
        "enter": "Mode <b>Dessin %label%</b> activé",
        "enter1": "Mode <b>Analyse %label%</b> activé",
        "enterAnalysis": "Mode <b> %label%</b> activé",
        "drawing": "Vous êtes actuellement en mode <b>Dessin %label%</b>",
        "drawing1": "Vous êtes actuellement en mode <b>Analyse %label%</b>",
        "drawingAnalysis": "Vous êtes actuellement en mode <b>%label%</b>",
        "quit": "Sortie du mode <b>Dessin %label%</b>",
        "quit1": "Sortie du mode <b>Analyse %label%</b>",
        "quitAnalysis":  "Sortie du mode <b>%label%</b>",
        "example": "Quel est le sujet de votre %label% ?",
        "flowchart": "Organigramme",
        "mindmap": "Carte mentale",
        "table": "Tableau",
        "list": "Liste",
        "timeline": "Chronologie",
        "swot": "Analyse SWOT",
        "pest": "Analyse PEST",
        "canvas": "Lean canvas",
        "story": "Récit utilisateur",
        "portrait": "Profil utilisateur",
        "gantt": "Gantt",
        "graph": "Graphique",
        "org": "Organigramme",
        "line": "Graphiques en courbes",
        "bar": "Graphiques à barres",
        "pie": "Graphiques en secteurs",
        "scatter": "Nuage de points",
        "candlestick": "Graphique en chandeliers",
        "radar": "Graphique en radar",
        "boxplot": "Diagramme en boîte",
        "heatmap": "Carte thermique",
        "graphChart": "Graphique relationnel",
        "sunburst": "Graphique en rayons de soleil",
        "parallel": "Coordonnées parallèles",
        "sankey": "Diagramme Sankey",
        "funnel": "Graphique en entonnoir",
        "gauge": "Cadran",
        "pictureAnalysis": "Analyse d'image",
        "documentAnalysis": "Analyse de documents",
        "textAnalysis": "Analyse de texte",
        "pictureAnalysisText": "Quelle image souhaiteriez-vous analyser ? Vous pouvez charger l'image en cliquant sur le bouton de chargement d'image.",
        "documentAnalysisText": "Quel fichier souhaiteriez-vous analyser ?  Vous pouvez télécharger le fichier en cliquant sur le bouton de chargement de fichier.",
        "textAnalysisText": "Sélectionnez du texte sur le canevas et demandez-moi de l'analyser.",
        "role-realtionships": "人物关系图",
        "drawed": "Généré dans la zone de dessin",
        "hotshape-flowchart": "Exemple : générer un processus de recrutement RH. Il ne devrait pas y avoir plus de 10 étapes, de la publication d'informations sur le poste jusqu'à l'émission d'une offre. Ces étapes comprennent notamment le filtrage des CV, l'organisation des entretiens, la vérification des antécédents et la détermination du salaire. ",
        "hotshape-mindmap": "Exemple : générer un brainstorming pour un produit écologique qui devrait résoudre un problème environnemental existant, tel que la pollution plastique ou les pénuries d'eau. Pour atteindre cet objectif, vous pouvez envisager d'utiliser des matériaux durables et de réduire les déchets. Des plans de conception spécifiques et des descriptions des caractéristiques doivent être fournis. ",
        "hotshape-table": "Exemple : générer un tableau des ventes de véhicules à énergie nouvelle pour 2022, y compris le nombre d'unités vendues, ainsi que des informations telles que le type de véhicule (électrique ou hybride), la marque et le mois, et classer par type et par pays. ",
        "hotshape-list": "Exemple : générer une liste de conseils pour entretenir les relations avec les clients. Celle-ci doit indiquer comment établir et entretenir une bonne relation avec le client, comment gérer les plaintes et les problèmes, ainsi que cinq compétences générales et deux compétences clés pour assurer la satisfaction du client. ",
        "hotshape-timeline": "Exemple : générer une chronologie du développement d'Internet de 2000 à 2023. ",
        "market-swot": "Exemple : analyse SWOT du secteur des plats à emporter",
        "market-pest": "Exemple : analyse de l'environnement du marché des véhicules à énergie nouvelle",
        "market-canvas": "Exemple : analyser le business model de Disney",
        "user-story": "Exemple : carte de récit utilisateur de taxi en ligne",
        "user-portrait": "Exemple : profil utilisateur de tablette",
        "textCheck": "Restez avec nous pendant que votre texte est examiné.",
        "matchStr": "Voulez-vous vraiment générer un %key% ?",
        "flowAnalyseStr": "Je suis en train d'analyser le diagramme que vous avez sélectionné aussi vite que possible. Merci de votre patience.",
        "flowchartCreating": "OK, %key%",
        "flowchartNotSelect": "Veuillez d'abord sélectionner la forme de l'organigramme sur la zone de dessin avant de continuer",
        "flowchartCreated": "« %key% » terminé.",
        "addFlowchartTips1": "voir l'exemple suivant pour recevoir directement un message expliquant comment l’ajouter. ",
        "addFlowchartTips2": "Exemple : Ajoutez un [processus de vérification des informations de compte] après [Enregistrer un compte d'utilisateur].",
        "modeUnsupport": "Désolé, la fonction IA d'Edraw ne prend pas en charge ce type de diagramme actuellement. Veuillez cliquer sur le bouton Créer un diagramme  en-dessous pour voir les diagrammes pris en charge par la fonction IA d'Edraw. Merci de votre compréhension.",
        "aiChatEnter": "Voici AI Q&A. Veuillez saisir la question que vous souhaitez poser dans la zone de saisie en dessous.",
        "aiChatStatus": "Vous avez actuellement le statut AI Q&A.",
        "httpError1": "Points IA insuffisants",
        "httpError2": "Vérifiez votre connexion réseau.",
        "httpError3": "Erreur réseau. Aucune donnée renvoyée depuis l'interface IA",
        "cleanStatus": "Salir",
        "no": "Non",
        "echart-line": "Exemple :Affichez les changements de température moyenne mondiale annuels de l'année 2010 à 2020.",
        "echart-bar": "Exemple :Comparez les tailles de population des 5 premiers pays du monde en 2023.",
        "echart-pie": "Exemple :Affichez la répartition du budget d'une entreprise, y compris des départements tels que la R&D, les ventes et les opérations.",
        "echart-scatter": "Exemple :Dessinez un graphique de distribution de l'IMC pour les adultes basé sur les données de taille et de poids.",
        "echart-candlestick": "Exemple :Affichez la tendance du prix de l'action d'une grande entreprise Inc. au cours des 30 derniers jours, y compris le prix d'ouverture quotidien, le prix de clôture, le prix le plus élevé et le prix le plus bas.",
        "echart-radar": "Exemple :Comparez les performances des cinq principaux constructeurs automobiles en 2023 en termes de ventes, de profits, de part de marché, de satisfaction client et d'amitié environnementale.",
        "echart-boxplot": "案例",
        "echart-heatmap": "Exemple :Affichez les visites du site Web pour une semaine, avec l'axe des x représentant l'heure de la journée (24 heures) et l'axe des y représentant du lundi au dimanche.",
        "echart-graph": "Exemple :Affichez un graphique de réseau social, où les nœuds représentent des individus et les arêtes représentent des relations entre eux.",
        "echart-sunburst": "案例",
        "echart-parallel": "Exemple :Comparez plusieurs caractéristiques de différents vins, y compris la teneur en alcool, l'acidité, la douceur, etc.",
        "echart-sankey": "Exemple :Représentez le flux d'énergie d'une ville, de la génération, la distribution à l'utilisation.",
        "echart-funnel": "Exemple :Affichez l'entonnoir de comportement d'achat d'un utilisateur de site Web, de la visite du site Web, de la recherche de produits, de l'ajout au panier, jusqu'à l'achat final.",
        "echart-gauge": "Exemple :Affichez le taux d'utilisation actuel du CPU, de 0% à 100%.",
        "echart-success": "Graphique généré sur le canevas",
        "echart-fail": "La génération du graphique a échoué. Veuillez essayer une autre invite ou télécharger un nouveau fichier de données.",
        "echart-inputtips": "Vous pouvez charger des fichiers pour générer des graphiques ou saisir directement la description du graphique que vous souhaitez générer.",
        "unselect-shape-error": "Veuillez d'abord sélectionner une forme, puis poursuivez avec l'opération.",
        "upload-image-fail": "Le téléchargement de l'image a échoué.",
        "image-size-error": "La taille de l'image ne peut pas dépasser 20MB.",
        "flowchart-error": "Nous sommes vraiment désolés pour ce problème, nous n'avons pas pu traiter votre dessin. Ne vous inquiétez pas, nous avons réinitialisé les points d'IA utilisés sur votre compte. Réessayez lorsque vous le souhaitez.",
        "suggest-tip": "Vous voudrez peut-être aussi demander :"
    },
    "de": {
        "aiName": "Edraw AI",
        "draw": "Ich möchte %1 zeichnen",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "Generierung manuell beendet",
        "enter": "<b>Zeichenmodus für %label%</b> aufgerufen",
        "enter1": "<b>Modus für %label%-Analysen</b> aufgerufen",
        "enterAnalysis": "<b>Modus für %label%</b> aufgerufen",
        "drawing": "Sie befinden sich derzeit im <b>Zeichenmodus für %label%</b>",
        "drawing1": "Sie befinden sich derzeit im <b>Zeichenmodus für %label%-Analysen</b>",
        "drawingAnalysis": "Sie befinden sich derzeit im <b>Zeichenmodus für %label%</b>",
        "quit": "<b>Zeichenmodus für %label%</b> verlassen",
        "quit1": "<b>Modus für %label%-Analysen</b> verlassen",
        "quitAnalysis":  "<b>Modus für %label%</b> verlassen",
        "example": "Welches Thema soll Ihre %label% haben?",
        "flowchart": "Flussdiagramm",
        "mindmap": "Mindmap",
        "table": "Tabelle",
        "list": "Liste",
        "timeline": "Zeitachse",
        "swot": "SWOT-Analyse",
        "pest": "STEP-Analyse",
        "canvas": "Lean Canvas",
        "story": "User Story",
        "portrait": "Benutzerprofil",
        "gantt": "Gantt",
        "graph": "Diagramm",
        "org": "Organigramm",
        "line": "Liniendiagramme",
        "bar": "Balkendiagramme",
        "pie": "Kreisdiagramme",
        "scatter": "Streudiagramm",
        "candlestick": "Kerzendiagramm",
        "radar": "Netzdiagramm",
        "boxplot": "Kastendiagramm",
        "heatmap": "Wärmebild",
        "graphChart": "Relationsdiagramm",
        "sunburst": "Sunburst-Diagramm",
        "parallel": "Parallele Koordinaten",
        "sankey": "Sankey-Diagramm",
        "funnel": "Trichterdiagramm",
        "gauge": "Zifferblatt",
        "pictureAnalysis": "Bildanalyse",
        "documentAnalysis": "Dokumentanalyse",
        "textAnalysis": "Textanalyse",
        "pictureAnalysisText": "Welches Bild möchten Sie analysieren? Sie können das Bild hochladen, indem Sie auf die entsprechende Schaltfläche klicken.",
        "documentAnalysisText": "Welche Datei möchten Sie analysieren?  Sie können die Datei hochladen, indem Sie auf die entsprechende Schaltfläche klicken.",
        "textAnalysisText": "Wählen Sie Text auf dem Canvas aus und bitten Sie mich um eine Analyse.",
        "role-realtionships": "人物关系图",
        "drawed": "Auf dem Canvas erstellt",
        "hotshape-flowchart": "Beispiel: Personalbeschaffungsprozess generieren. Von der Veröffentlichung von Stellenangeboten bis zur Unterbreitung eines Angebots sollten weniger als 10 Schritte erforderlich sein. Zu diesen Schritten sollten unter anderem das Filtern von Lebensläufen, das Organisieren von Vorstellungsgesprächen, das Durchführen von Hintergrundprüfungen und das Festlegen des Gehalts gehören. ",
        "hotshape-mindmap": "Beispiel: Erstellen Sie ein Konzept für ein umweltfreundliches Produkt, das ein bestehendes Umweltproblem lösen soll, z. B. die Verschmutzung durch Plastik oder die Wasserknappheit. Um dieses Ziel zu erreichen, können Sie die Verwendung nachhaltiger Materialien und die Reduzierung von Abfällen in Betracht ziehen, wobei spezifische Gestaltungspläne und Beschreibungen von Merkmalen vorgelegt werden müssen. ",
        "hotshape-table": "Beispiel: Erstellen Sie eine Tabelle der Verkaufszahlen von Neufahrzeugen für das Jahr 2022, einschließlich der Anzahl der verkauften Einheiten, sowie Informationen zu Fahrzeugtyp (Elektro- oder Hybridfahrzeug), Marke und Monat, und kategorisieren Sie nach Typ und Land. ",
        "hotshape-list": "Beispiel: Erstellen Sie eine Liste mit Tipps zur Pflege von Kundenbeziehungen. Dazu gehören der Aufbau und die Pflege einer guten Kundenbeziehung, der Umgang mit Beschwerden und Problemen sowie fünf allgemeine Fähigkeiten und zwei Schlüsselkompetenzen für die Kundenzufriedenheit. ",
        "hotshape-timeline": "Beispiel: Erstellen Sie eine Zeitachse über die Entwicklung des Internets von 2000 bis 2023. ",
        "market-swot": "Beispiel: Eine SWOT-Analyse der Imbissbranche",
        "market-pest": "Beispiel: Eine Analyse des Marktumfelds für neue Elektrofahrzeuge",
        "market-canvas": "Beispiel: Das Geschäftsmodell von Disney analysieren",
        "user-story": "Beispiel: Karte für Online-Taxi User Story",
        "user-portrait": "Beispiel: Ein Tablet-Benutzerprofil",
        "textCheck": "Bitte haben Sie etwas Geduld, während Ihr Text überprüft wird.",
        "matchStr": "Möchten Sie wirklich ein(e) %key% erstellen?",
        "flowAnalyseStr": "Ich analysiere das ausgewählte Flussdiagramm so schnell wie möglich. Bitte haben Sie einen Moment Geduld.",
        "flowchartCreating": "OK, %key%",
        "flowchartNotSelect": "Wählen Sie zunächst die Flussdiagramm-Form auf dem Canvas aus, bevor Sie fortfahren",
        "flowchartCreated": "„%key%“ abgeschlossen.",
        "addFlowchartTips1": "Sie können auf den folgenden Fall verweisen, um die Art der Einschränkung direkt über eine Chat-Nachricht zu kommunizieren. ",
        "addFlowchartTips2": "Beispiel: Fügen Sie nach [Benutzerkonto-Registrierung] einen [Kontoinformationen-Prüfprozess] hinzu.",
        "modeUnsupport": "Edraw AI unterstützt diesen Diagrammtyp derzeit nicht. Klicken Sie unten auf die Schaltfläche „Diagramm erstellen“, um die Diagramme anzuzeigen, die Edraw AI unterstützt. Vielen Dank für Ihr Verständnis.",
        "aiChatEnter": "Willkommen bei den AI-Fragen. Geben Sie die Frage, die Sie stellen möchten, in das Eingabefeld unten ein.",
        "aiChatStatus": "Sie befinden sich derzeit im „AI-Fragen“-Status.",
        "httpError1": "Unzureichende AI-Punkte",
        "httpError2": "Bitte überprüfen Sie Ihre Netzwerkverbindung.",
        "httpError3": "Netzwerkfehler. Keine Daten von der KI-Schnittstelle erhalten",
        "cleanStatus": "Beenden",
        "no": "Nein",
        "echart-line": "Beispiel: Zeigen Sie die jährlichen globalen Durchschnittstemperaturänderungen von 2010 bis 2020 an.",
        "echart-bar": "Beispiel: Vergleichen Sie die Bevölkerungsgrößen der Top 5 Länder der Welt im Jahr 2023.",
        "echart-pie": "Beispiel: Zeigen Sie die Budgetverteilung eines Unternehmens an, einschließlich Abteilungen wie F&E, Vertrieb und Betrieb.",
        "echart-scatter": "Beispiel: Erstellen Sie ein BMI-Verteilungsdiagramm für Erwachsene basierend auf Höhen- und Gewichtsdaten.",
        "echart-candlestick": "Beispiel: Zeigen Sie den Aktienpreistrend eines großen Unternehmens Inc. in den letzten 30 Tagen, einschließlich des täglichen Eröffnungspreises, Schlusspreises, Höchstpreises und Tiefstpreises an.",
        "echart-radar": "Beispiel: Vergleichen Sie die Leistung der fünf führenden Autohersteller im Jahr 2023 hinsichtlich Verkäufen, Gewinnen, Marktanteilen, Kundenzufriedenheit und Umweltfreundlichkeit.",
        "echart-boxplot": "案例",
        "echart-heatmap": "Beispiel: Zeigen Sie die Website-Besuche für eine Woche an, wobei die x-Achse die Tageszeit (24 Stunden) und die y-Achse Montag bis Sonntag darstellt.",
        "echart-graph": "Beispiel: Zeigen Sie ein Sozialnetzwerkdiagramm an, in dem Knoten Individuen darstellen und Kanten Beziehungen zwischen ihnen darstellen.",
        "echart-sunburst": "案例",
        "echart-parallel": "Beispiel: Vergleichen Sie mehrere Eigenschaften verschiedener Weine, einschließlich Alkoholgehalt, Säuregehalt, Süße, usw.",
        "echart-sankey": "Beispiel: Stellen Sie den Energiefluss einer Stadt dar, von der Erzeugung, Verteilung bis zur Nutzung.",
        "echart-funnel": "Beispiel: Zeigen Sie den Einkaufsverhaltens-Trichter eines Website-Benutzers an, vom Besuch der Website, der Suche nach Produkten, dem Hinzufügen zum Warenkorb, bis zum endgültigen Kauf.",
        "echart-gauge": "Beispiel: Zeigen Sie die aktuelle CPU-Auslastungsrate an, von 0% bis 100%.",
        "echart-success": "Diagramm auf Canvas generiert",
        "echart-fail": "Die Generierung des Diagramms ist fehlgeschlagen. Bitte versuchen Sie einen anderen Befehl oder laden Sie eine neue Datendatei hoch.",
        "echart-inputtips": "Sie können Dateien hochladen, um Diagramme zu generieren. Sie können auch die Beschreibung des Diagramms, das Sie generieren möchten, direkt eingeben.",
        "unselect-shape-error": "Bitte wählen Sie zuerst eine Form aus, dann fahren Sie mit der Operation fort.",
        "upload-image-fail": "Bildupload fehlgeschlagen.",
        "image-size-error": "Die Größe des Bildes darf 20MB nicht überschreiten.",
        "flowchart-error": "Es tut uns wirklich leid – Ihr Diagramm konnte nicht verarbeitet werden. Aber keine Sorge, wir haben Ihnen die AI-Punkte direkt wieder gutgeschrieben. Versuchen Sie es später erneut.",
        "suggest-tip": "Sie möchten vielleicht auch fragen:"
    },
    "jp": {
        "aiName": "Edraw AI",
        "draw": "%1を描画します",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "生成が手動で停止されました",
        "enter": "<b>%label%描画</b>モードに切り替えました",
        "enter1": "<b>%label%分析</b>モードに切り替えました",
        "enterAnalysis": "<b>%label%</b>モードに切り替えました",
        "drawing": "現在、<b>フ%label%描画</b>モードです",
        "drawing1": "現在、<b>%label%分析</b>モードです",
        "drawingAnalysis": "現在、<b>%label%</b>モードです",
        "quit": "<b>%label%描画</b>モードを終了しました",
        "quit1": "<b>%label%分析</b>モードを終了しました",
        "quitAnalysis":  "<b>%label%</b>モードを終了しました",
        "example": "%label%のテーマを何にしますか？",
        "flowchart": "フローチャート",
        "mindmap": "マインドマップ",
        "table": "テーブル",
        "list": "リスト",
        "timeline": "タイムライン",
        "swot": "SWOT分析",
        "pest": "PEST分析",
        "canvas": "リーンキャンバス",
        "story": "ユーザーストーリー",
        "portrait": "ユーザープロファイル",
        "gantt": "ガントチャート",
        "graph": "チャート",
        "org": "組織図",
        "line": "折れ線グラフ",
        "bar": "棒グラフ",
        "pie": "円グラフ",
        "scatter": "散布図",
        "candlestick": "ローソク足チャート",
        "radar": "レーダーチャート",
        "boxplot": "箱ひげ図",
        "heatmap": "ヒートマップ",
        "graphChart": "関係グラフ",
        "sunburst": "サンバースト図",
        "parallel": "平行座標",
        "sankey": "サンキーダイアグラム",
        "funnel": "じょうごグラフ",
        "gauge": "ダイヤル",
        "pictureAnalysis": "画像解析",
        "documentAnalysis": "ドキュメント解析",
        "textAnalysis": "テキスト分析",
        "pictureAnalysisText": "何の写真を解析しますか？画像アップロードボタンをクリックすると、画像をアップロードできます。",
        "documentAnalysisText": "何のファイルを解析しますか？  ファイルアップロードボタンをクリックすると、ファイルをアップロードできます。",
        "textAnalysisText": "キャンバス上のテキストを選択し、分析を依頼してください。",
        "role-realtionships": "人物关系图",
        "drawed": "キャンバスに生成済み",
         "hotshape-flowchart": "例：人事採用プロセスを生成します。役割に関する情報の公開から、オファーの発行までのステップは10ステップ未満にする必要があります。ステップには、履歴書のフィルター処理、面接の手配、バックグラウンドチェックの実施、給与の決定などが含まれますが、これらに限定されません。 ",
        "hotshape-mindmap": "例：プラスチック汚染や水不足など、既存の環境問題を解決する、環境に優しい製品に関するブレインストーミングを生成します。この目標を達成するために、持続可能な素材の使用と廃棄物の削減を検討することができます。また、具体的なデザインプランと特徴の説明を提供する必要があります。",
        "hotshape-table": "例：2022年の新しいエネルギー車販売表を生成します。販売台数に加えて、車種（電気またはハイブリッド）、ブランド、月などの情報を生成し、タイプと国別に分類します。",
        "hotshape-list": "例：クライアントとの関係を維持するためのヒントのリストを生成します。クライアントとの良好な関係を築き、維持する方法、苦情や問題に対処する方法、さらに顧客満足度を提供するための5つの一般的なスキルと2つの主要なスキルを含める必要があります。",
        "hotshape-timeline": "例：2000年から2023年までのインターネット開発のタイムラインを生成します。",
        "market-swot": "例：テイクアウト業界のSWOT分析",
        "market-pest": "例：新しいエネルギー車市場環境の分析",
        "market-canvas": "例：Disneyのビジネスモデルの分析",
        "user-story": "例：オンラインタクシーユーザーストーリーマップ",
        "user-portrait": "例：タブレットユーザー プロファイル",
        "textCheck": "入力内容を確認するまで、お待ちください。",
        "matchStr": "%key%を生成しますか？",
        "flowAnalyseStr": "選択したフローチャートをできるだけ早く分析します。お待ちください。",
        "flowchartCreating": "%key%",
        "flowchartNotSelect": "先に進む前に、まずキャンバスでフローチャートの図形を選択してください",
        "flowchartCreated": "「%key%」が完了しました。",
        "addFlowchartTips1": "了解しました。次の例を参照して、補足方法のチャットを直接送信します。 ",
        "addFlowchartTips2": "例：[ユーザーアカウントを登録]の後に[アカウント情報プロセスを検証]を追加します。",
        "modeUnsupport": "申し訳ありません。Edraw AIでは現在このタイプの図がサポートされていません。下部の[図を作成]ボタンをクリックし、Edraw AIでサポートされる図を確認してください。ご了承いただきありがとうございます。",
        "aiChatEnter": "AI Q&Aへようこそ。下部の入力ボックスに質問内容を入力してください。",
        "aiChatStatus": "現在、AI Q&Aステータスです。",
        "httpError1": "AIポイントが不足しています",
        "httpError2": "ネットワーク接続を確認してください。",
        "httpError3": "ネットワークエラーです。AIインターフェイスからデータが返されませんでした",
        "cleanStatus": "終了",
        "no": "いいえ",
        "echart-line": "例：2010年から2020年までの年間の全球平均温度の変化を表示します。",
        "echart-bar": "例：2023年の世界のトップ5カ国の人口を比較します。",
        "echart-pie": "例：企業の予算配分を表示します。これには、R&D、営業、運営などの部署が含まれます。",
        "echart-scatter": "例：身長と体重のデータに基づいて、大人のBMI分布チャートを描く。",
        "echart-candlestick": "例：大手企業Inc.の過去30日間の株価の動きを表示します。これには、日々の始値、終値、最高値、最低値が含まれます。",
        "echart-radar": "例：2023年の売上、利益、市場シェア、顧客満足度、環境に優しいという観点から、トップ5の自動車メーカーのパフォーマンスを比較してください。",
        "echart-boxplot": "案例",
        "echart-heatmap": "例：一週間のウェブサイトの訪問を表示します、x軸は一日の時間（24時間）を表し、y軸は月曜日から日曜日を表します。",
        "echart-graph": "例：ソーシャルネットワークグラフを表示します。ここで、ノードは個々の人を表し、エッジはそれらの間の関係を表します。",
        "echart-sunburst": "案例",
        "echart-parallel": "例：異なるワインのいくつかの特性を比較してください。アルコール含有量、酸度、甘さなど。",
        "echart-sankey": "例：都市のエネルギーフローを描写してください、発生から、配布、使用まで。",
        "echart-funnel": "例：ウェブサイトのユーザーのショッピング行動ファンネルを表示します。ウェブサイトの訪問から、製品の検索、ショッピングカートへの追加、最終的な購入まで。",
        "echart-gauge": "例：現在のCPU使用率を表示します、0％から100％まで。",
        "echart-success": "キャンバスにチャートを生成しました",
        "echart-fail": "チャートの生成に失敗しました。他のプロンプトを試すか、新しいデータファイルをアップロードしてください。",
        "echart-inputtips": "チャートを生成するには、チャートを生成するファイルをアップロードするか、生成したいチャートを説明する文章を入力します。",
        "unselect-shape-error": "まず形状を選択してから、操作を進めてください。",
        "upload-image-fail": "画像のアップロードに失敗しました。",
        "image-size-error": "画像のサイズは20MBを超えることはできません。",
        "flowchart-error": "申し訳ございません。図を処理できませんでした。AIポイントをアカウントに返却しました。よろしければ別の図面をお試しください。",
        "suggest-tip": "また、次のことを尋ねることもできます："
    },
    "es": {
        "aiName": "IA de Edraw",
        "draw": "Quiero dibujar %1",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "La generación se ha detenido manualmente",
        "enter": "Ha entrado en el modo <b>dibujo de %label%</b>",
        "enter1": "Ha entrado en el modo <b>análisis de %label%</b>",
        "enterAnalysis": "Ha entrado en el modo <b> %label%</b>",
        "drawing": "Ahora mismo se encuentra en el modo <b>dibujo de %label%</b>",
        "drawing1": "Ahora mismo se encuentra en el modo <b>análisis de %label%</b>",
        "drawingAnalysis": "Ahora mismo se encuentra en el modo <b>%label%</b>",
        "quit": "Ha salido del modo <b>dibujo de %label%</b>",
        "quit1": "Ha salido del modo <b>análisis de %label%</b>",
        "quitAnalysis":  "Ha salido del modo <b>%label%</b>",
        "example": "¿Qué tema te gustaría que tratase el %label%?",
        "flowchart": "Diagrama de flujo",
        "mindmap": "Mapa mental",
        "table": "Tabla",
        "list": "Lista",
        "timeline": "Línea de tiempo",
        "swot": "Análisis DAFO",
        "pest": "Análisis PEST",
        "canvas": "Lienzo en blanco",
        "story": "Historia de usuario",
        "portrait": "Perfil de usuario",
        "gantt": "Gantt",
        "graph": "Gráfico",
        "org": "Orgchart",
        "line": "Gráficos de líneas",
        "bar": "Gráficos de barras",
        "pie": "Gráficos circulares",
        "scatter": "Diagrama de dispersión",
        "candlestick": "Gráfico candelabro",
        "radar": "Gráfico radial",
        "boxplot": "Diagrama de caja",
        "heatmap": "Mapa térmico",
        "graphChart": "Gráfico relacional",
        "sunburst": "Gráfico de proyección solar",
        "parallel": "Coordenadas paralelas",
        "sankey": "Diagrama de Sankey",
        "funnel": "Gráfico de embudo",
        "gauge": "Dial",
        "pictureAnalysis": "Análisis de imágenes",
        "documentAnalysis": "Análisis de documentos",
        "textAnalysis": "Análisis de texto",
        "pictureAnalysisText": "¿Qué imagen deseas analizar? Puedes cargar la imagen haciendo clic en el botón correspondiente.",
        "documentAnalysisText": "¿Qué archivo deseas analizar?  Puedes cargar el archivo haciendo clic en el botón correspondiente.",
        "textAnalysisText": "Selecciona texto en el lienzo y pídeme el análisis.",
        "role-realtionships": "人物关系图",
        "drawed": "Generación en el lienzo",
        "hotshape-flowchart": "Ejemplo: Generar un proceso de contratación de RR. HH. Debe haber menos de 10 pasos, empezando por la publicación de información sobre el puesto y terminando con la emisión de una oferta. Los pasos deben incluir, entre otros, el filtrado de currículos, la organización de entrevistas, la realización de comprobaciones de antecedentes y la determinación del salario. ",
        "hotshape-mindmap": "Ejemplo: Intercambiar ideas sobre un producto ecológico que debería resolver un problema medioambiental, como la contaminación por plásticos o la escasez de agua. Puede considerar el uso de materiales sostenibles y la reducción de residuos para lograr este objetivo, y se deben proporcionar planes de diseño específicos y descripciones de características.",
        "hotshape-table": "Ejemplo: Generar una nueva tabla de ventas de vehículos ecológicos para 2022, incluido el número de unidades vendidas, así como información como el tipo de vehículo (eléctrico o híbrido), la marca y el mes, y categorizar por tipo y país. ",
        "hotshape-list": "Ejemplo: Genere una lista de consejos para mantener las relaciones con los clientes. Debe incluir cómo consolidar y mantener una buena relación con el cliente, cómo gestionar las quejas y los problemas, así como cinco habilidades generales y dos habilidades clave para conseguir la satisfacción del cliente. ",
        "hotshape-timeline": "Ejemplo: Generar una línea de tiempo del desarrollo de Internet desde el año 2000 hasta 2023. ",
        "market-swot": "Ejemplo: Un análisis DAFO del sector de comida para llevar.",
        "market-pest": "Ejemplo: Un análisis del nuevo entorno del mercado de vehículos ecológicos.",
        "market-canvas": "Ejemplo: Analizar el modelo de negocio de Disney.",
        "user-story": "Ejemplo: Un mapa de caso de usuarios de taxis en línea.",
        "user-portrait": "Ejemplo: Un perfil de usuario de tableta.",
        "textCheck": "Ten paciencia con nosotros mientras se revisa el texto.",
        "matchStr": "¿Seguro que deseas generar %key%?",
        "flowAnalyseStr": "Estoy analizando el diagrama de flujo seleccionado lo más rápido posible. Espera unos instantes.",
        "flowchartCreating": "De acuerdo, %key%",
        "flowchartNotSelect": "Antes de continuar, seleccione primero la forma del diagrama de flujo en el lienzo",
        "flowchartCreated": "[%key%] completado.",
        "addFlowchartTips1": "Puede consultar el siguiente caso para enviar directamente un chat indicándome cómo perfeccionarlo. ",
        "addFlowchartTips2": "Ejemplo: Añade un [Proceso de verificación de la información de la cuenta] después de [Registrar cuenta de usuario].",
        "modeUnsupport": "Lo sentimos, por el momento Edraw AI no es compatible con este tipo de diagrama. Haga clic en el botón Crear diagrama en la parte inferior para ver los diagramas compatibles con Edraw AI. Gracias por su comprensión.",
        "aiChatEnter": "Le damos la bienvenida a las preguntas y respuestas sobre IA Introduzca la pregunta que desee formular en el cuadro de texto de la parte inferior.",
        "aiChatStatus": "Ahora mismo, se encuentra en el estado de preguntas y respuestas sobre AI.",
        "httpError1": "Puntos de IA insuficientes",
        "httpError2": "Comprueba tu conexión a la red.",
        "httpError3": "Generierung manuell beendet",
        "cleanStatus": "Salir",
        "no": "No",
        "echart-line": "Ejemplo: Muestra los cambios en la temperatura media global anual desde el año 2010 hasta 2020.",
        "echart-bar": "Ejemplo: Compara el tamaño de la población de los 5 países más grandes del mundo en 2023.",
        "echart-pie": "Ejemplo: Muestra la asignación de presupuesto de una empresa, incluyendo departamentos como I+D, ventas y operaciones.",
        "echart-scatter": "Ejemplo: Dibuja un gráfico de distribución del IMC para adultos basado en datos de altura y peso.",
        "echart-candlestick": "Ejemplo: Muestra la tendencia del precio de las acciones de una gran empresa Inc. durante los últimos 30 días, incluyendo el precio de apertura diario, el precio de cierre, el precio más alto y el precio más bajo.",
        "echart-radar": "Ejemplo: Compare el rendimiento de los cinco principales fabricantes de automóviles en 2023 en términos de ventas, ganancias, participación de mercado, satisfacción del cliente y amabilidad con el medio ambiente.",
        "echart-boxplot": "案例",
        "echart-heatmap": "Ejemplo: Muestre las visitas al sitio web durante una semana, con el eje x representando la hora del día (24 horas) y el eje y representando de lunes a domingo.",
        "echart-graph": "Ejemplo: Muestra un gráfico de red social, donde los nodos representan individuos y las aristas representan relaciones entre ellos.",
        "echart-sunburst": "案例",
        "echart-parallel": "Ejemplo: Compare varias características de diferentes vinos, incluyendo el contenido de alcohol, acidez, dulzura, etc.",
        "echart-sankey": "Ejemplo: Depicta el flujo de energía de una ciudad, desde la generación, distribución hasta el uso.",
        "echart-funnel": "Ejemplo: Muestra el embudo de comportamiento de compra de un usuario del sitio web, desde la visita al sitio web, la búsqueda de productos, la adición al carrito de compras, hasta la compra final.",
        "echart-gauge": "Ejemplo: Muestra la tasa de uso actual de la CPU, del 0% al 100%.",
        "echart-success": "Gráfico generado en lienzo",
        "echart-fail": "La generación del gráfico ha fallado. Por favor, intente con otra indicación o suba un nuevo archivo de datos.",
        "echart-inputtips": "Puedes cargar archivos para generar gráficos, o directamente puedes introducir la descripción del gráfico que deseas generar.",
        "unselect-shape-error": "Por favor, selecciona una forma primero, luego procede con la operación.",
        "upload-image-fail": "La carga de la imagen ha fallado.",
        "image-size-error": "El tamaño de la imagen no puede exceder los 20MB.",
        "flowchart-error": "Lamentamos el contratiempo, tu dibujo no se ha completado correctamente. Pero no te preocupes, hemos devuelto esos puntos de IA a tu cuenta. Vuelve a intentarlo cuando quieras.",
        "suggest-tip": "También querrás preguntar:"
    },
    "pt": {
        "aiName": "IA do Edraw",
        "draw": "Quero desenhar %1",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "Geração interrompida manualmente",
        "enter": "Entrou no modo de <b>Desenho do %label%</b>",
        "enter1": "Entrou no modo de <b>Análise de %label%</b>",
        "enterAnalysis": "Entrou no modo de <b>%label%</b>",
        "drawing": "Você está atualmente no modo de <b>Desenho do %label%</b>",
        "drawing1": "Você está atualmente no modo de <b>Análise de %label%</b>",
        "drawingAnalysis": "Você está atualmente no modo de <b>%label%</b>",
        "quit": "Saiu do modo de <b>Desenho do %label%</b>",
        "quit1": "Saiu do modo de <b>Análise de %label%</b>",
        "quitAnalysis":  "Saiu do modo de <b>%label%</b>",
        "example": "Você gostaria que o %label% de ideias fosse sobre qual assunto?",
        "flowchart": "Fluxograma",
        "mindmap": "Mapa mental",
        "table": "Tabela",
        "list": "Lista",
        "timeline": "Linha do tempo",
        "swot": "Análise SWOT",
        "pest": "Análise PEST",
        "canvas": "Lean Canvas",
        "story": "História do usuário",
        "portrait": "Perfil do usuário",
        "gantt": "Gantt",
        "graph": "Gráfico",
        "org": "Organograma",

        "line": "Gráficos de linha",
        "bar": "Gráfico de barras",
        "pie": "Gráficos de pizza",
        "scatter": "Dispersão",
        "candlestick": "Gráfico de castiçal",
        "radar": "Gráfico de radar",
        "boxplot": "Diagrama em caixa",
        "heatmap": "Mapa de calor",
        "graphChart": "Gráfico relacional",
        "sunburst": "Gráfico de explosão solar",
        "parallel": "Coordenadas paralelas",
        "sankey": "Diagrama de Sankey",
        "funnel": "Gráfico de funil",
        "gauge": "Marcação",
        "pictureAnalysis": "Análise de imagem",
        "documentAnalysis": "Análise de documento",
        "textAnalysis": "Análise de texto",
        "pictureAnalysisText": "Qual imagem você gostaria de analisar? Você pode carregar a imagem clicando no botão de upload de imagem.",
        "documentAnalysisText": "Qual arquivo você gostaria de analisar?  Você pode carregar o arquivo clicando no botão de upload de arquivo.",
        "textAnalysisText": "Selecione o texto na tela e peça-me para analisar.",
        "role-realtionships": "人物关系图",
        "drawed": "Gerado na tela",
        "hotshape-flowchart": "Exemplo: gerar um processo de recrutamento de RH. Deve haver menos de 10 etapas, começando com a publicação de informações sobre a função e terminando com a emissão de uma oferta. As etapas devem incluir, entre outras, a filtragem de currículos, a organização de entrevistas, a realização de verificações de antecedentes e a determinação do salário. ",
        "hotshape-mindmap": "Exemplo: gerar um brainstorm para um produto ecologicamente correto que deve resolver um problema ambiental existente, como poluição por plástico ou escassez de água. Você pode considerar o uso de materiais sustentáveis e a redução de resíduos para atingir essa meta e planos de projeto e descrições de recursos específicos devem ser fornecidos. ",
        "hotshape-table": "Exemplo: gerar uma tabela de vendas de veículos de energias novas para 2022, incluindo o número de unidades vendidas, informações como o tipo de veículo (elétrico ou híbrido), a marca e o mês e categorizar por tipo e país. ",
        "hotshape-list": "Exemplo: gerar uma lista de dicas para manter relacionamentos com clientes. Ela deve incluir como construir e manter um bom relacionamento com o cliente, como lidar com reclamações e problemas, e também cinco habilidades gerais e duas habilidades principais para fornecer satisfação ao cliente. ",
        "hotshape-timeline": "Exemplo: gerar um cronograma do desenvolvimento da Internet de 2000 a 2023. ",
        "market-swot": "Exemplo: Uma análise FOFA do setor de comida para viagem",
        "market-pest": "Exemplo: uma análise do ambiente do mercado de veículo de energia nova",
        "market-canvas": "Exemplo: analisar o modelo de negócios da Disney",
        "user-story": "Exemplo: mapa de história de usuário de táxi on-line",
        "user-portrait": "Exemplo: um perfil de usuário de tablet",
        "textCheck": "Aguarde enquanto seu texto está sendo revisado.",
        "matchStr": "Tem certeza de que deseja gerar %key%?",
        "flowAnalyseStr": "Estou analisando o fluxograma selecionado o mais rápido possível. Seja paciente.",
        "flowchartCreating": "好的，正在%key%",
        "flowchartNotSelect": "Primeiro, selecione a forma do fluxograma na tela antes de continuar",
        "flowchartCreated": "[%key%] concluído.",
        "addFlowchartTips1": "OK. Veja o exemplo a seguir para enviar uma mensagem diretamente a mim dizendo como complementá-la. ",
        "addFlowchartTips2": "Exemplo: adicione um [processo para verificar dados da conta] após [registrar conta de usuário].",
        "modeUnsupport": "O Edraw AI não é compatível com esse tipo de diagrama no momento. Clique no botão Criar diagrama na parte inferior para ver os diagramas compatíveis com o Edraw AI. Agradecemos a sua compreensão.",
        "aiChatEnter": "Boas-vindas às Perguntas e respostas sobre IA. Insira a pergunta que deseja fazer na caixa de entrada na parte inferior.",
        "aiChatStatus": "Você está atualmente no status de Perguntas e respostas sobre IA.",
        "httpError1": "Pontos de IA insuficientes",
        "httpError2": "Verifique sua conexão de rede.",
        "httpError3": "Erro de rede. Nenhum dado retornado da interface de IA",
        "cleanStatus": "Sair",
        "no": "Não",
        "echart-line": "Exemplo: Exiba as alterações na temperatura média global anual de 2010 a 2020.",
        "echart-bar": "Exemplo: Compare o tamanho da população dos 5 maiores países do mundo em 2023.",
        "echart-pie": "Exemplo: Mostra a alocação de orçamento de uma empresa, incluindo departamentos como P&D, vendas e operações.",
        "echart-scatter": "Exemplo: Desenhe um gráfico de distribuição de IMC para adultos com base em dados de altura e peso.",
        "echart-candlestick": "Exemplo: Mostre a tendência do preço das ações de uma grande empresa Inc. nos últimos 30 dias, incluindo o preço de abertura diário, o preço de fechamento, o preço mais alto e o preço mais baixo.",
        "echart-radar": "Exemplo: Compare o desempenho dos cinco principais fabricantes de carros em 2023 em termos de vendas, lucros, participação de mercado, satisfação do cliente e amizade com o meio ambiente.",
        "echart-boxplot": "案例",
        "echart-heatmap": "Exemplo: Mostre as visitas ao site por uma semana, com o eixo x representando a hora do dia (24 horas) e o eixo y representando de segunda a domingo.",
        "echart-graph": "Exemplo: Exiba um gráfico de rede social, onde os nós representam indivíduos e as arestas representam relações entre eles.",
        "echart-sunburst": "案例",
        "echart-parallel": "Exemplo: Compare várias características de diferentes vinhos, incluindo o teor de álcool, acidez, doçura, etc.",
        "echart-sankey": "Exemplo: Depicta o fluxo de energia de uma cidade, desde a geração, distribuição até o uso.",
        "echart-funnel": "Exemplo: Mostre o funil de comportamento de compra de um usuário do site, desde a visita ao site, a busca por produtos, a adição ao carrinho de compras, até a compra final.",
        "echart-gauge": "Exemplo: Exiba a taxa de uso atual da CPU, de 0% a 100%.",
        "echart-success": "Gráfico gerado na tela",
        "echart-fail": "A geração do gráfico falhou. Por favor, tente outro prompt ou faça o upload de um novo arquivo de dados.",
        "echart-inputtips": "Você pode carregar arquivos para gerar gráficos ou inserir diretamente a descrição do gráfico que deseja gerar.",
        "unselect-shape-error": "Por favor, selecione uma forma primeiro, depois prossiga com a operação.",
        "upload-image-fail": "Falha no upload da imagem.",
        "image-size-error": "O tamanho da imagem não pode exceder 20MB.",
        "flowchart-error": "Desculpe pelo transtorno. Tivemos um problema ao processar o seu desenho. Mas não se preocupe, já devolvemos esses pontos de IA à sua conta. Tente novamente quando quiser.",
        "suggest-tip": "Você também pode querer perguntar:"
    },
    "it": {
        "aiName": "Edraw AI",
        "draw": "Voglio disegnare %1",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "Generazione interrotta manualmente",
        "enter": "Modalità <b>Disegno %label%</b> attivata",
        "enter1": "Modalità <b>Analisi %label%</b> attivata",
        "enterAnalysis": "Modalità <b>%label%</b> attivata",
        "drawing": "Attualmente, ti trovi in modalità <b>Disegno %label%</b>",
        "drawing1": "Attualmente, ti trovi in modalità <b>Analisi %label%</b>",
        "drawingAnalysis": "Attualmente, ti trovi in modalità <b>%label%</b>",
        "quit": "Modalità <b>Disegno %label%</b> disattivata",
        "quit1": "Modalità <b>Analisi %label%</b> disattivata",
        "quitAnalysis":  "Modalità <b>%label%</b> disattivata",
        "example": "Quale argomento vuoi trattare nella %label%?",
        "flowchart": "Diagramma di flusso",
        "mindmap": "Mappa mentale",
        "table": "Tabella",
        "list": "Elenco",
        "timeline": "Cronologia",
        "swot": "Analisi SWOT",
        "pest": "Analisi PEST",
        "canvas": "Lean Canvas",
        "story": "Storia utente",
        "portrait": "Profilo utente",
        "gantt": "Gantt",
        "graph": "Diagramma",
        "org": "Organigramma",
        "line": "Grafici a linee",
        "bar": "Grafici a barre",
        "pie": "Grafici a torta",
        "scatter": "Grafico di dispersione",
        "candlestick": "Grafico a candela",
        "radar": "Grafico radar",
        "boxplot": "Box plot",
        "heatmap": "Mappa termica",
        "graphChart": "Diagramma relazionale",
        "sunburst": "Grafico radiale",
        "parallel": "Coordinate parallele",
        "sankey": "Diagramma di Sankey",
        "funnel": "Grafico a imbuto",
        "gauge": "Quadrante",
        "pictureAnalysis": "Analisi immagine",
        "documentAnalysis": "Analisi documento",
        "textAnalysis": "Analisi testo",
        "pictureAnalysisText": "Quale immagine desideri analizzare? Puoi caricare l'immagine facendo clic sul pulsante per il caricamento dell'immagine.",
        "documentAnalysisText": "Quale file desideri analizzare?  È possibile caricare il file facendo clic sul pulsante di caricamento del file.",
        "textAnalysisText": "Seleziona il testo sull'area di lavoro e chiedi di eseguire l'analisi.",
        "role-realtionships": "人物关系图",
        "drawed": "Generato sull'area di lavoro",
        "hotshape-flowchart": "Contoh: Genera il diagramma della procedura di reclutamento delle risorse umane. Utilizza meno di 10 fasi, partendo dalla pubblicazione delle informazioni sul ruolo e terminando con la formulazione dell'offerta. Le fasi devono includere, ma non essere limitate a, lo screening dei curriculum, l'organizzazione dei colloqui, il controllo dei precedenti e la determinazione dello stipendio. ",
        "hotshape-mindmap": "Contoh: Buat curah pikiran tentang produk ramah lingkungan yang dapat menjawab masalah lingkungan saat ini, seperti limbah plastik atau menipisnya sumber daya air. Untuk mencapai tujuan ini, Anda dapat mempertimbangkan penggunaan bahan berkelanjutan dan pengurangan limbah. Rencana desain dan deskripsi fitur yang spesifik juga harus disediakan. ",
        "hotshape-table": "Contoh: Buat tabel penjualan kendaraan energi baru untuk tahun 2022, termasuk jumlah unit yang terjual dan berbagai informasi, seperti jenis kendaraan (listrik atau hibrid), merek, dan bulan, lalu kategorikan menurut jenis dan negara. ",
        "hotshape-list": "Contoh: Buat daftar kiat menjaga hubungan dengan klien. Instruksi tersebut harus mencakup kiat membangun dan menjaga hubungan yang baik dengan klien, kiat menangani keluhan dan masalah, serta lima keterampilan umum dan dua keterampilan utama untuk memuaskan klien. ",
        "hotshape-timeline": "Contoh: Buat lini masa perkembangan internet dari tahun 2000 sampai 2023. ",
        "market-swot": "Contoh: Analisis SWOT industri makanan yang dibawa pulang",
        "market-pest": "Contoh: Analisis lingkungan pasar kendaraan dengan energi baru",
        "market-canvas": "Contoh: Analisis model bisnis Disney",
        "user-story": "Contoh: Peta kisah pengguna taksi online",
        "user-portrait": "Contoh: Profil pengguna produk tablet",
        "textCheck": "Ti chiediamo un po' di pazienza durante le revisione del testo.",
        "matchStr": "Rimuovere %key%?",
        "flowAnalyseStr": "Sto analizzando il diagramma di flusso selezionato il più velocemente possibile. Un po' di pazienza.",
        "flowchartCreating": "%key%",
        "flowchartNotSelect": "Prima di procedere, seleziona la forma del diagramma di flusso nell'area di lavoro",
        "flowchartCreated": "[%key%] completato.",
        "addFlowchartTips1": "Vedi l'esempio seguente per richiedere informazioni tramite chat su come effettuare l'integrazione. ",
        "addFlowchartTips2": "Esempio: Aggiungi un [processo di verifica delle informazioni sull'account] dopo [Registra account utente].",
        "modeUnsupport": "Attualmente, Edraw AI non supporta questo tipo di diagramma. Fai clic sul pulsante Crea diagramma in basso per visualizzare i diagrammi supportati da Edraw AI. Grazie per la comprensione.",
        "aiChatEnter": "Benvenuto nella sezione Domande e risposte sull'AI. Inserisci la domanda desiderata nella casella di input in basso.",
        "aiChatStatus": "Attualmente, ti trovi nello stato delle domande e risposte sull'AI.",
        "httpError1": "Punti AI insufficienti",
        "httpError2": "Controlla la connessione di rete.",
        "httpError3": "Errore di rete. Nessun dato restituito dall'interfaccia AI",
        "cleanStatus": "Chiudi",
        "no": "No",
        "echart-line": "Contoh: Mostra le variazioni della temperatura media globale annuale dal 2010 al 2020.",
        "echart-bar": "Contoh: Confronta le dimensioni della popolazione dei primi 5 paesi del mondo nel 2023.",
        "echart-pie": "Contoh: Mostra la ripartizione del budget di un'azienda, compresi dipartimenti come R&D, vendite e operazioni.",
        "echart-scatter": "Contoh: Disegna un grafico della distribuzione del BMI per gli adulti basato sui dati di altezza e peso.",
        "echart-candlestick": "Contoh: Mostra l'andamento del prezzo delle azioni di una grande azienda Inc. negli ultimi 30 giorni, compreso il prezzo di apertura quotidiano, il prezzo di chiusura, il prezzo più alto e il prezzo più basso.",
        "echart-radar": "Contoh: Confronta le prestazioni dei cinque principali produttori di automobili nel 2023 in termini di vendite, profitti, quota di mercato, soddisfazione del cliente e amicizia con l'ambiente.",
        "echart-boxplot": "案例",
        "echart-heatmap": "Contoh: Mostra le visite al sito web per una settimana, con l'asse x che rappresenta l'ora del giorno (24 ore) e l'asse y che rappresenta da lunedì a domenica.",
        "echart-graph": "Contoh: Mostra un grafico di rete sociale, dove i nodi rappresentano individui e gli archi rappresentano relazioni tra di loro.",
        "echart-sunburst": "案例",
        "echart-parallel": "Contoh: Confronta diverse caratteristiche di diversi vini, tra cui il contenuto di alcol, l'acidità, la dolcezza, ecc.",
        "echart-sankey": "Contoh: Rappresenta il flusso energetico di una città, dalla generazione, distribuzione all'uso.",
        "echart-funnel": "Contoh: Mostra il funnel di comportamento d'acquisto di un utente del sito web, dalla visita del sito, la ricerca di prodotti, l'aggiunta al carrello, fino all'acquisto finale.",
        "echart-gauge": "Contoh: Mostra l'attuale tasso di utilizzo della CPU, dal 0% al 100%.",
        "echart-success": "Grafico generato sull'area di lavoro",
        "echart-fail": "La generazione del grafico è fallita. Si prega di provare un altro prompt o caricare un nuovo file di dati.",
        "echart-inputtips": "Puoi caricare file per generare grafici o immettere direttamente la descrizione del grafico che desideri generare.",
        "unselect-shape-error": "Si prega di selezionare prima una forma, poi procedere con l'operazione.",
        "upload-image-fail": "Caricamento dell'immagine non riuscito.",
        "image-size-error": "La dimensione dell'immagine non può superare i 20MB.",
        "flowchart-error": "Siamo spiacenti per l'inconveniente. Il tuo disegno non può essere elaborato. Non preoccuparti, abbiamo restituito i punti AI al tuo account. Riprova quando sei pronto.",
        "suggest-tip": "Potresti anche voler chiedere:"
    },
    "tw": {
        "aiName": "Edraw AI",
        "draw": "我想繪製%1",
        "drawTip": "好的，你的下一条指令将会进行%label%的作图",
        "manulQuit": "已手動停止產生",
        "enter": "已進入<b>%label%繪製</b>模式",
        "enter1": "已進入<b>%label%分析</b>模式",
        "enterAnalysis": "已進入<b>%label%</b>模式",
        "drawing": "您目前處於<b>%label%繪製</b>模式",
        "drawing1": "您目前處於<b>%label%分析</b>模式",
        "drawingAnalysis": "您目前處於<b>%label%</b>模式",
        "quit": "已結束<b>%label%繪製</b>模式",
        "quit1": "已結束<b>%label%分析</b>模式",
        "quitAnalysis":  "已結束<b>%label%</b>模式",
        "example": "您希望產生什麼主題的%label%？",
        "flowchart": "流程圖",
        "mindmap": "心智圖",
        "table": "表格",
        "list": "清單",
        "timeline": "時間軸",
        "swot": "SWOT分析",
        "pest": "PEST分析",
        "canvas": "精實畫布",
        "story": "使用者案例",
        "portrait": "使用者設定檔",
        "gantt": "甘特圖",
        "graph": "圖表",
        "org": "組織結構圖",
        "line": "折線圖",
        "bar": "長條圖",
        "pie": "圓形圖",
        "scatter": "散布圖",
        "candlestick": "蠟燭圖",
        "radar": "雷達圖",
        "boxplot": "箱形圖",
        "heatmap": "熱圖",
        "graphChart": "關係圖",
        "sunburst": "放射環狀圖",
        "parallel": "平行座標",
        "sankey": "Sankey 圖",
        "funnel": "漏斗圖",
        "gauge": "儀表盤",
        "pictureAnalysis": "圖片分析",
        "documentAnalysis": "文件分析",
        "textAnalysis": "文字分析",
        "pictureAnalysisText": "您想要分析什麼圖片？按一下圖片上傳按鈕，即可上傳圖片。",
        "documentAnalysisText": "您想要分析什麼檔案？  按一下檔案上傳按鈕，即可上傳檔案。",
        "textAnalysisText": "選取畫布上的文字並要求我進行分析。",
        "role-realtionships": "人物关系图",
        "drawed": "已在畫布上產生",
        "hotshape-flowchart": "範例：產生人力資源招募流程。從發佈職位資訊開始，到發出錄取通知結束，步驟應少於 10 個。這些步驟應包括但不限於篩選履歷、安排面試、進行背景調查，以及決定薪資。 ",
        "hotshape-mindmap": "範例：針對環保產品進行腦力激盪，以解決現有的環境問題，例如塑膠污染或水資源短缺。您可以考慮使用永續材料並減少廢棄物以達成此目標，同時也必須提供特定的設計方案和功能說明。",
        "hotshape-table": "範例：針對 2022 年產生新的能源車輛銷售表，包括售出的單位數量，以及車輛類型 (電動或油電混合車)、品牌和月份等資訊，並依類型和國家分類。",
        "hotshape-list": "範例：產生維護客戶關係的提示清單。其中必須包括如何建立和維持良好的客戶關係，如何處理客訴和問題，以及五項一般技能和兩項關鍵技能，以提供客戶滿意度。",
        "hotshape-timeline": "範例：產生 2000 年到 2023 年的網際網路發展時間軸。",
        "market-swot": "範例：外帶產業的 SWOT 分析",
        "market-pest": "範例：新能源車輛市場環境的分析",
        "market-canvas": "範例：分析迪士尼的商業模式",
        "user-story": "範例：線上計程車使用者案例地圖",
        "user-portrait": "範例：平板電腦使用者設定檔",
        "textCheck": "我們正在檢查您的文字，請耐心等候。",
        "matchStr": "確定要產生 %key%？",
        "flowAnalyseStr": "正在盡快分析您所選的流程圖。請耐心等候。",
        "flowchartCreating": "好的，正在%key%",
        "flowchartNotSelect": "繼續進行前，請先在畫布上選取流程圖形狀",
        "flowchartCreated": "「%key%」已完成。",
        "addFlowchartTips1": "好的，請參閱下列範例，直接傳送對話告訴我該如何補充邏輯例外。",
        "addFlowchartTips2": "範例：在 [註冊使用者帳戶] 之後新增 [驗證帳戶資訊流程]。",
        "modeUnsupport": "很抱歉，Edraw AI 目前並不支援此類型的圖表。請按一下底部的「建立圖表」按鈕以查看 Edraw AI 支援的圖表。感謝您的體諒。",
        "aiChatEnter": "歡迎來到 AI 問答集。請在底部的輸入方塊中輸入您要詢問的問題。",
        "aiChatStatus": "您目前處於 AI 問答狀態。",
        "httpError1": "AI 點數不足",
        "httpError2": "請檢查您的網路連線。",
        "httpError3": "網路錯誤。AI 介面未傳回任何資料",
        "cleanStatus": "結束",
        "no": "否",
        "echart-line": "範例：顯示2010年至2020年每年的全球平均溫度變化。",
        "echart-bar": "範例：比較2023年世界前五大國家的人口大小。",
        "echart-pie": "範例：顯示公司的預算分配，包括如研發、銷售和運營等部門。",
        "echart-scatter": "範例：根據身高和體重數據，繪製一張成人BMI分佈圖。",
        "echart-candlestick": "範例：顯示大公司. 過去30天的股價趨勢，包括每日開盤價、收盤價、最高價和最低價。",
        "echart-radar": "範例：請比較2023年五大汽車製造商在銷售、利潤、市場份額、客戶滿意度和環保方面的表現。",
        "echart-boxplot": "案例",
        "echart-heatmap": "範例：顯示一周的網站訪問次數，其中x軸代表一天中的時間（24小時），y軸代表星期一至星期日。",
        "echart-graph": "範例：顯示一個社交網路圖，其中節點代表個人，邊緣代表他們之間的關係。",
        "echart-sunburst": "案例",
        "echart-parallel": "範例：比較不同酒的幾個特性，包括酒精含量、酸度、甜度等。",
        "echart-sankey": "範例：描繪一個城市的能源流動，從產生、分配到使用。",
        "echart-funnel": "範例：顯示網站用戶的購物行為漏斗，從訪問網站，搜尋產品，添加到購物車，到最終購買。",
        "echart-gauge": "範例：顯示當前的CPU使用率，從0%到100%。",
        "echart-success": "在畫布上產生的圖表",
        "echart-fail": "圖表生成失敗。請嘗試其他提示或上傳新的資料檔案。",
        "echart-inputtips": "您可以上傳檔案來產生圖表，或直接輸入您想要產生之圖表的描述。",
        "unselect-shape-error": "請先選擇一個形狀，然後進行操作。",
        "upload-image-fail": "圖片上傳失敗。",
        "image-size-error": "圖片的大小不能超過20MB。",
        "flowchart-error": "很抱歉，我們無法處理您的繪圖。不過別擔心，我們已將這些 AI 點數直接退回您的帳戶。當您準備好時，請再試一次。",
        "suggest-tip": "您可能也想問："
    },
    "kr": {
        "line": "선형 차트",
        "bar": "막대 차트",
        "pie": "원형 차트",
        "scatter": "산포도",
        "candlestick": "캔들스틱 차트",
        "radar": "방사형 차트",
        "boxplot": "박스 플롯",
        "heatmap": "히트맵",
        "graphChart": "관계형 그래프",
        "sunburst": "선버스트 차트",
        "parallel": "평행 좌표",
        "sankey": "생키 다이어그램",
        "funnel": "깔때기 차트",
        "gauge": "다이얼",
        "pictureAnalysis": "사진 분석",
        "documentAnalysis": "문서 분석",
        "textAnalysis": "텍스트 분석",
        "pictureAnalysisText": "어떤 사진을 분석하시겠습니까? 사진 업로드 버튼을 클릭하여 사진을 업로드할 수 있습니다.",
        "documentAnalysisText": "어떤 파일을 분석하시겠습니까?  파일 업로드 버튼을 클릭하여 파일을 업로드할 수 있습니다.",
        "textAnalysisText": "캔버스에서 텍스트를 선택하고 분석을 요청하세요.",
        "echart-success": "캔버스에 생성된 차트",
        "echart-fail": "차트 생성이 실패했습니다. 다른 프롬프트를 시도하거나 새 데이터 파일을 업로드해 주세요.",
        "echart-inputtips": "파일을 업로드하여 차트를 생성하거나 생성할 차트의 설명을 직접 입력할 수 있습니다.",
        "unselect-shape-error": "먼저 모양을 선택한 후 작업을 계속하십시오.",
        "upload-image-fail": "이미지 업로드 실패.",
        "image-size-error": "이미지의 크기는 20MB를 초과할 수 없습니다.",
        "flowchart-error": "죄송합니다. 문제가 발생했습니다. 귀하의 드로잉이 처리되지 않았습니다. 하지만 걱정하지 마세요. 해당 AI 포인트는 귀하의 계정으로 바로 반환됩니다. 준비가 되면 다시 돌려보세요.",
        "suggest-tip": "또한 다음을 물어보고 싶을 수 있습니다:",
        "echart-line": "2010년부터 2020년까지의 연간 전세계 평균 온도 변화를 표시합니다.",
        "echart-bar": "2023년 세계에서 가장 인구가 많은 5개 국가의 인구를 비교하세요.",
        "echart-pie": "회사의 예산 배분을 보여줍니다. 이에는 R&D, 판매, 운영 등의 부서가 포함됩니다.",
        "echart-scatter": "키와 체중 데이터를 기반으로 한 성인의 BMI 분포 차트를 그립니다.",
        "echart-candlestick": "대기업 Inc.의 지난 30일간의 주가 추세를 보여줍니다. 이에는 일일 시가, 종가, 최고가, 최저가가 포함됩니다.",
        "echart-radar": "2023년 판매, 이익, 시장 점유율, 고객 만족도, 환경 친화성 측면에서 상위 5개 자동차 제조업체의 성능을 비교하십시오.",
        "echart-boxplot": "案例",
        "echart-heatmap": "일주일 동안의 웹사이트 방문을 보여주며, x축은 하루의 시간(24시간)을 나타내고, y축은 월요일부터 일요일까지를 나타냅니다.",
        "echart-graph": "소셜 네트워크 그래프를 표시하십시오. 여기서 노드는 개인을 나타내고 엣지는 그들 사이의 관계를 나타냅니다.",
        "echart-sunburst": "案例",
        "echart-parallel": "다양한 와인의 여러 특성을 비교하세요, 알코올 함량, 산도, 단맛 등을 포함하여.",
        "echart-sankey": "도시의 에너지 흐름을 묘사하십시오, 발생에서 배포, 사용까지.",
        "echart-funnel": "웹사이트 사용자의 쇼핑 행동 퍼널을 보여줍니다. 웹사이트 방문, 제품 검색, 장바구니에 추가, 최종 구매까지.",
        "echart-gauge": "현재 CPU 사용률을 표시하십시오, 0%에서 100%까지."
    }
}
</i18n>
